<!--
  功能：AI报告2.0
  作者：wangwenhao
  邮箱：wangwenhao@gw.com.cn
  时间：2023-09-08 13:29:05
  版本：v2.0
  修改记录：
  修改内容：
  修改人员：
  修改时间：
-->
<template>
  <div class="background-report">
    <!-- 导航栏 -->
    <van-nav-bar title="因子调优报告" class="haider-info">
      <template #left>
        <van-icon name="arrow-left" size="18" color="#ffffff" @click="closeHtml()" />
      </template>
      <template #right>
        <div @click="shareHtml()" v-if="!mnQuery && !searchInfo" style="padding: 10px">
          <i class="right-icon"></i>
        </div>
      </template>
    </van-nav-bar>
    <!-- 生成报告的时间 -->
    <div class="report-time" v-if="!mnQuery">
      报告生成时间: <span> {{ bgTime }} </span>
    </div>

    <div class="report-content" v-if="!mnQuery">
      <!-- 走势/调优数据变化 -->
      <div class="content-gl content-bg">
        <div class="gl-title">{{ yzData.hq ? yzData.hq.FactorName : '' }}</div>
        <div class="gl-code">{{ yzData.hq ? yzData.hq.IndexCode!==''?yzData.hq.IndexCode : yzData.hq.FactorCode :'' }}</div>
        <!-- 调优参数 -->
        <div class="gl-tycs" @click="showMbName()">
          <span class="gl-tycs-title">调优参数</span>
          <i :class="showMbInfo ? 'topI' : 'downI'"></i>
        </div>
        <div class="gl-item" :class="showMbInfo ? 'max-gl-item' : ''">
          <ul>
            <li v-for="(item, index) in nameArr" :key="index">
              <span>{{ item }}</span>
            </li>
          </ul>
        </div>
        <!-- 概述 -->
        <div class="gs-text-background">
          <span class="gs-text-info">概述：</span>
          <span
            >因子调优后，今日信号数{{ glxhsText }}，组合整体<span :class="'tg' + glzhBool">{{
              glzhBool == 1
                ? '表现优秀'
                : glzhBool == 2
                ? '表现欠佳'
                : glzhBool == 3
                ? '表现一般'
                : ''
            }}</span
            >。</span
          >
          <!-- 短线 -->
          <span
            >从短线看，{{ dxZhangFuText }}涨幅<span v-if="dxShengJiang == ''">变化不明显。</span>
            <span v-else
              >从{{ dxZhangFu1
              }}<span :class="'dxShengJiang-' + dxShengJiang">{{
                dxShengJiang == 'down' ? '下降' : dxShengJiang == 'up' ? '上升' : ''
              }}</span
              >到{{ dxZhangFu2 }}，<span v-if="dx300TongBi == 0.0">与同期大盘持平；</span
              ><span v-else
                >相比同期大盘超额收益为<span :class="[judgeColor(dx300TongBi)]"
                  >{{ toFixedNum(dx300TongBi,2,'%') }}</span
                >。</span
              >
            </span>
          </span>
          <!-- 长线 -->
          <span
            >长期来看，{{ cxZhangFuText }}涨幅<span v-if="cxShengJiang == ''">不变</span>
            <span v-else>
              <span :class="'dxShengJiang-' + cxShengJiang">{{
                cxShengJiang == 'down' ? '下降' : cxShengJiang == 'up' ? '提升' : ''
              }}</span
              >了{{ toFixedNum(cxMax, 2, '%') }}。</span
            >
          </span>
          <!-- 策略 -->
          <span
            >策略<span v-if="clText == ''">表现不佳，建议未来持续关注。</span>
            <span v-else>
              <span class="clTextBold">{{ clText }}</span
              >表现更佳，建议未来持续关注。
            </span>
          </span>
        </div>
        <!-- 近一年走势title -->
        <div>
          <span class="title-second-order">近一年走势</span>
          <span :class="'tag-signal' + glzhBool">{{
            glzhBool == 1
              ? '历史表现优秀'
              : glzhBool == 2
              ? '历史表现欠佳'
              : glzhBool == 3
              ? '历史表现一般'
              : ''
          }}</span>
        </div>
        <!-- 走势图 -->
        <div class="tb-height" id="zssy"></div>
        <!-- 调优数据标题 -->
        <div>
          <span class="title-second-order">调优数据变化</span>
        </div>
        <!-- 调优数据 -->
        <div class="ty-data-info">
          <div class="background-gray">
            <van-row gutter="16">
              <van-col span="12">
                <span class="data-title">调优前</span>
              </van-col>
              <van-col span="12">
                <span class="data-title">调优后</span>
              </van-col>
            </van-row>
            <van-row gutter="16">
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">日涨幅</span
                ><!--
								--><span class="item-right">{{
                  yzData.hq ? toFixedNum(yzData.hq.RiZhangFu * 100, 2, '%') : '--'
                }}</span>
              </van-col>
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">日涨幅</span
                ><!--
                --><span class="item-right"
                  >{{ tyData.hq ? toFixedNum(tyData.hq.RiZhangFu * 100, 2, '%') : '--'
                  }}<i
                    :class="
                      tyData.hq
                        ? 1 + yzData.hq.RiZhangFu > 1 + tyData.hq.RiZhangFu
                          ? 'greenDown'
                          : 1 + yzData.hq.RiZhangFu < 1 + tyData.hq.RiZhangFu
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i
                ></span>
              </van-col>
            </van-row>
            <!-- 近一年 -->
            <van-row gutter="16">
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">近一年</span>
                <span class="item-right">{{
                  yzData.hq ? toFixedNum(yzData.hq.ZhangFu360, 2, '%') : '--'
                }}</span>
              </van-col>
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">近一年</span>
                <span class="item-right"
                  >{{ tyData.hq ? toFixedNum(tyData.hq.ZhangFu360, 2, '%') : '--'
                  }}<i
                    :class="
                      tyData.hq
                        ? 1 + yzData.hq.ZhangFu360 > 1 + tyData.hq.ZhangFu360
                          ? 'greenDown'
                          : 1 + yzData.hq.ZhangFu360 < 1 + tyData.hq.ZhangFu360
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i
                ></span>
              </van-col>
            </van-row>
            <!-- 今日信号 -->
            <van-row gutter="16">
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">今日信号</span>
                <span class="item-right">{{
                  yzData.hq ? yzData.hq.XinHaoShuLiang + '只' : '--'
                }}</span>
              </van-col>
              <van-col span="12" class="text-flex-conten">
                <span class="item-left">今日信号</span>
                <span class="item-right">{{
                  tyData.hq ? tyData.hq.XinHaoShuLiang + '只' : '--'
                }}</span>
              </van-col>
            </van-row>
          </div>
        </div>
      </div>
      <!-- 历史回测对比 -->
      <div class="content-bg lshc-info">
        <!-- 标题 -->
        <div class="title-first-order marginBottom8">历史回测对比</div>
        <!-- 历史回测描述 -->
        <div class="background-gray marginBottom16">
          根据回测数据显示，调优后最优持股期为{{
            tyData.backTest
              ? tyData.backTest.BacktestAnalysisResult[lshcMaxIndex].HoldPeriod
              : '--'
          }}天，属于<span class="textBlueInfo">{{ lshcFengGe }}</span
          >风格。平均区间涨幅为<span
            :class="
              judgeColor(
                tyData.backTest
                  ? tyData.backTest.BacktestAnalysisResult[lshcMaxIndex].AvgSectionRate
                  : 0
              )
            "
            >{{
              tyData.backTest
                ? toFixedNum(
                    tyData.backTest.BacktestAnalysisResult[lshcMaxIndex].AvgSectionRate * 100,
                    2,
                    '%'
                  )
                : '--'
            }}</span
          >，市场表现<span>{{ lshcZhangFUShiChang }}</span
          >；历史上涨概率达<span
            :class="
              judgeColor(
                tyData.backTest
                  ? tyData.backTest.BacktestAnalysisResult[lshcMaxIndex].RiseProbability
                  : 0
              )
            "
            >{{
              tyData.backTest
                ? toFixedNum(
                    tyData.backTest.BacktestAnalysisResult[lshcMaxIndex].RiseProbability * 100,
                    2,
                    '%'
                  )
                : '--'
            }}</span
          >，市场对该策略的态度<span>{{ lshcShangZhangKaiLv }}</span
          >。
        </div>
        <!-- 历史统计回测 -->
        <van-row type="flex" justify="space-between">
          <van-col span="6">
            <div class="data-text text-left">指标名称</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">调优前</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">调优后</div>
          </van-col>
          <van-col span="6">
            <div class="data-text text-right">变动百分比</div>
          </van-col>
          <van-col span="24" class="title-third-order">
            <van-row justify="space-between">
              <van-col span="12">
                <div class="data-title-left">阶段回测统计（近一年）</div>
              </van-col>
              <van-col span="12" class="data-title-right" @click="showSheet">
                持股期{{
                  yzData.backTest
                    ? yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].HoldPeriod
                    : '1'
                }}天 <i class="text-right-icon"></i>
              </van-col>
            </van-row>
          </van-col>
          <!-- 平均区间涨幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">平均区间涨幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{
                    yzData.backTest
                      ? toFixedNum(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].AvgSectionRate *
                            100,
                          2,
                          '%'
                        )
                      : '--'
                  }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{
                    tyData.backTest
                      ? toFixedNum(
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].AvgSectionRate *
                            100,
                          2,
                          '%'
                        )
                      : '--'
                  }}<i
                    :class="
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .AvgSectionRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .AvgSectionRate * 100
                          ) < 0
                          ? 'greenDown'
                          : setSyTongBi(
                              yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .AvgSectionRate * 100,
                              tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .AvgSectionRate * 100
                            ) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .AvgSectionRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .AvgSectionRate * 100
                          )
                        : 0
                    )
                  "
                >
                  {{
                    yzData.backTest && tyData.backTest
                      ? setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].AvgSectionRate *
                            100,
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].AvgSectionRate *
                            100
                        ) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 最大涨跌服 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">最大涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{
                    yzData.backTest
                      ? toFixedNum(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{
                    tyData.backTest
                      ? toFixedNum(
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}<i
                    :class="
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100
                          ) < 0
                          ? 'greenDown'
                          : setSyTongBi(
                              yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate *
                                100,
                              tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate *
                                100
                            ) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100
                          )
                        : 0
                    )
                  "
                >
                  {{
                    yzData.backTest && tyData.backTest
                      ? setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100,
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MaxRate * 100
                        ) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 最小涨跌幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">最小涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{
                    yzData.backTest
                      ? toFixedNum(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{
                    tyData.backTest
                      ? toFixedNum(
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}<i
                    :class="
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100
                          ) < 0
                          ? 'greenDown'
                          : setSyTongBi(
                              yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate *
                                100,
                              tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate *
                                100
                            ) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100
                          )
                        : 0
                    )
                  "
                >
                  {{
                    yzData.backTest && tyData.backTest
                      ? setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100,
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].MinRate * 100
                        ) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 历史盈亏比 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">历史盈亏比</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{
                    yzData.backTest
                      ? toFixedNum(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].ProfitLossRatio,
                          2,
                          ''
                        )
                      : '--'
                  }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{
                    tyData.backTest
                      ? toFixedNum(
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].ProfitLossRatio,
                          2,
                          ''
                        )
                      : '--'
                  }}<i
                    :class="
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .ProfitLossRatio,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .ProfitLossRatio
                          ) < 0
                          ? 'greenDown'
                          : setSyTongBi(
                              yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .ProfitLossRatio,
                              tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .ProfitLossRatio
                            ) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .ProfitLossRatio,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .ProfitLossRatio
                          )
                        : 0
                    )
                  "
                >
                  {{
                    yzData.backTest && tyData.backTest
                      ? setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].ProfitLossRatio,
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex].ProfitLossRatio
                        ) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 历史上涨概率 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">历史上涨概率</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{
                    yzData.backTest
                      ? toFixedNum(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                            .RiseProbability * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{
                    tyData.backTest
                      ? toFixedNum(
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                            .RiseProbability * 100,
                          2,
                          '%'
                        )
                      : '--'
                  }}<i
                    :class="
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .RiseProbability * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .RiseProbability * 100
                          ) < 0
                          ? 'greenDown'
                          : setSyTongBi(
                              yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .RiseProbability * 100,
                              tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                                .RiseProbability * 100
                            ) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.backTest && tyData.backTest
                        ? setSyTongBi(
                            yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .RiseProbability * 100,
                            tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                              .RiseProbability * 100
                          )
                        : 0
                    )
                  "
                >
                  {{
                    yzData.backTest && tyData.backTest
                      ? setSyTongBi(
                          yzData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                            .RiseProbability * 100,
                          tyData.backTest.BacktestAnalysisResult[this.lshcMaxIndex]
                            .RiseProbability * 100
                        ) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 阶段涨跌统计标题 -->
          <van-col span="24" class="title-third-order">
            <van-row justify="space-between">
              <van-col span="24">
                <div class="data-title-left">阶段涨跌统计</div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 近一周涨跌幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">近一周涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{ yzData.hq ? toFixedNum(yzData.hq.ZhangFu5, 2, '%') : '--' }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{ tyData.hq ? toFixedNum(tyData.hq.ZhangFu5, 2, '%') : '--'
                  }}<i
                    :class="
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu5, tyData.hq.ZhangFu5) < 0
                          ? 'greenDown'
                          : setSyTongBi(yzData.hq.ZhangFu5, tyData.hq.ZhangFu5) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu5, tyData.hq.ZhangFu5)
                        : 0
                    )
                  "
                >
                  {{
                    yzData.hq && tyData.hq
                      ? setSyTongBi(yzData.hq.ZhangFu5, tyData.hq.ZhangFu5) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 近一月涨跌幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">近一月涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{ yzData.hq ? toFixedNum(yzData.hq.ZhangFu20, 2, '%') : '--' }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{ tyData.hq ? toFixedNum(tyData.hq.ZhangFu20, 2, '%') : '--'
                  }}<i
                    :class="
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu20, tyData.hq.ZhangFu20) < 0
                          ? 'greenDown'
                          : setSyTongBi(yzData.hq.ZhangFu20, tyData.hq.ZhangFu20) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu20, tyData.hq.ZhangFu20)
                        : 0
                    )
                  "
                >
                  {{
                    yzData.hq && tyData.hq
                      ? setSyTongBi(yzData.hq.ZhangFu20, tyData.hq.ZhangFu20) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 近三月涨跌幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">近三月涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{ yzData.hq ? toFixedNum(yzData.hq.ZhangFu60, 2, '%') : '--' }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{ tyData.hq ? toFixedNum(tyData.hq.ZhangFu60, 2, '%') : '--'
                  }}<i
                    :class="
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu60, tyData.hq.ZhangFu60) < 0
                          ? 'greenDown'
                          : setSyTongBi(yzData.hq.ZhangFu60, tyData.hq.ZhangFu60) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu60, tyData.hq.ZhangFu60)
                        : 0
                    )
                  "
                >
                  {{
                    yzData.hq && tyData.hq
                      ? setSyTongBi(yzData.hq.ZhangFu60, tyData.hq.ZhangFu60) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
          <!-- 近半年涨跌幅 -->
          <van-col span="24">
            <van-row class="padding8Info">
              <van-col span="6">
                <div class="data-text3 text-left">近半年涨跌幅</div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right">
                  {{ yzData.hq ? toFixedNum(yzData.hq.ZhangFu180, 2, '%') : '--' }}
                </div>
              </van-col>
              <van-col span="6">
                <div class="data-text3 text-right flexIcon">
                  {{ tyData.hq ? toFixedNum(tyData.hq.ZhangFu180, 2, '%') : '--'
                  }}<i
                    :class="
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu180, tyData.hq.ZhangFu180) < 0
                          ? 'greenDown'
                          : setSyTongBi(yzData.hq.ZhangFu180, tyData.hq.ZhangFu180) > 0
                          ? 'redTop'
                          : ''
                        : ''
                    "
                  ></i>
                </div>
              </van-col>
              <van-col span="6">
                <div
                  class="data-text3 text-right"
                  :class="
                    judgeColor(
                      yzData.hq && tyData.hq
                        ? setSyTongBi(yzData.hq.ZhangFu180, tyData.hq.ZhangFu180)
                        : 0
                    )
                  "
                >
                  {{
                    yzData.hq && tyData.hq
                      ? setSyTongBi(yzData.hq.ZhangFu180, tyData.hq.ZhangFu180) + '%'
                      : '--'
                  }}
                </div>
              </van-col>
            </van-row>
          </van-col>
        </van-row>
      </div>
      <!-- 当日股池对比 -->
      <div class="content-bg drgc-info">
        <!-- 标题 -->
        <div class="title-first-order marginBottom8">当日股池对比</div>
        <!-- 当然股池描述 -->
        <div class="background-gray marginBottom16">
          调优后，今日信号数{{ drgcXinHaoShuLiang }}，股池总体表现<span
            :class="
              drgcZongFenBiaoXian == '更佳'
                ? 'textRedInfo'
                : drgcZongFenBiaoXian == '欠佳'
                ? 'textGreenInfo'
                : ''
            "
            >{{ drgcZongFenBiaoXian }}</span
          >
          ，{{ drgcTongBiText }}。<span v-if="drgcDataShow" >调优后股池中有<!--
		  --><span v-if="tyData.TodayPoolData && tyData.TodayPoolData.ZhangTingCnt > 0"
            ><span class="textRedInfo"
              >{{ tyData.TodayPoolData ? tyData.TodayPoolData.ZhangTingCnt : '0' }}只</span
            >今日涨停，</span
          ><!--
		  --><span v-if="tyData.TodayPoolData && tyData.TodayPoolData.LianBanCnt > 0"
            ><span class="textRedInfo"
              >{{ tyData.TodayPoolData ? tyData.TodayPoolData.LianBanCnt : '0' }}只</span
            >连板，</span
          ><!--
		  --><span v-if="tyData.TodayPoolData && tyData.TodayPoolData.QiangShiCnt > 0"
            ><span class="textRedInfo"
              >{{ tyData.TodayPoolData ? tyData.TodayPoolData.QiangShiCnt : '0' }}只</span
            >近期强势，</span
          ><!--
		  --><span v-if="tyData.TodayPoolData && tyData.TodayPoolData.DuanQiXinGaoCnt > 0"
            ><span class="textRedInfo"
              >{{ tyData.TodayPoolData ? tyData.TodayPoolData.DuanQiXinGaoCnt : '0' }}只</span
            >创短期新高，</span
          ><!--
		  --><span v-if="tyData.TodayPoolData && tyData.TodayPoolData.LongHuBangCnt > 0"
            ><span class="textRedInfo"
              >{{ tyData.TodayPoolData ? tyData.TodayPoolData.LongHuBangCnt : '0' }}只</span
            >登上龙虎榜，</span
          ><!--
		  -->表现亮眼。</span>
        </div>
        <!-- 专业评级标题 -->
        <div class="marginBottom8">
          <span class="title-second-order">专业评级</span>
        </div>
        <!-- 雷达图 -->
        <div class="marginBottom8">
          <div id="radarEchars" class="radarEchars"></div>
        </div>
        <!-- 雷达图数据 -->
        <div>
          <div class="background-gray">
            <van-row gutter="22">
              <!-- 总分 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">总分</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{ yzData.hq ? yzData.zongFen : '--' }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{ tyData.hq ? tyData.zongFen : '--' }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.hq
                              ? yzData.zongFen > tyData.zongFen
                                ? 'greenDown'
                                : yzData.zongFen < tyData.zongFen
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <!-- 技术 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">技术</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{
                        yzData.TechData ? yzData.TechData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{
                        tyData.TechData ? tyData.TechData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.TechData
                              ? yzData.TechData.FenShu > tyData.TechData.FenShu
                                ? 'greenDown'
                                : yzData.TechData.FenShu < tyData.TechData.FenShu
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <!-- 基本 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">基本</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{
                        yzData.BasicData ? yzData.BasicData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{
                        tyData.BasicData ? tyData.BasicData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.BasicData
                              ? yzData.BasicData.FenShu > tyData.BasicData.FenShu
                                ? 'greenDown'
                                : yzData.BasicData.FenShu < tyData.BasicData.FenShu
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <!-- 资金 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">资金</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{
                        yzData.ZiJinData ? yzData.ZiJinData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{
                        tyData.ZiJinData ? tyData.ZiJinData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.ZiJinData
                              ? yzData.ZiJinData.FenShu > tyData.ZiJinData.FenShu
                                ? 'greenDown'
                                : yzData.ZiJinData.FenShu < tyData.ZiJinData.FenShu
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <!-- 题材 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">题材</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{
                        yzData.TiCaiData ? yzData.TiCaiData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{
                        tyData.TiCaiData ? tyData.TiCaiData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.TiCaiData
                              ? yzData.TiCaiData.FenShu > tyData.TiCaiData.FenShu
                                ? 'greenDown'
                                : yzData.TiCaiData.FenShu < tyData.TiCaiData.FenShu
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
              <!-- 避雷 -->
              <van-col span="12" class="padding4Info">
                <van-row justify="space-between" class="zong-felx">
                  <van-col span="6">
                    <div class="fenshu-left-text">避雷</div>
                  </van-col>
                  <van-col span="18">
                    <div class="right-flex">
                      <span class="fenshu-right-text">{{
                        yzData.BiLeiData ? yzData.BiLeiData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon">
                        <i class="rightArrow"></i>
                      </span>
                      <span class="fenshu-right-text">{{
                        tyData.BiLeiData ? tyData.BiLeiData.FenShu : '--'
                      }}</span>
                      <span class="fenshu-right-icon2">
                        <i
                          :class="
                            tyData.BiLeiData
                              ? yzData.BiLeiData.FenShu > tyData.BiLeiData.FenShu
                                ? 'greenDown'
                                : yzData.BiLeiData.FenShu < tyData.BiLeiData.FenShu
                                ? 'redTop'
                                : ''
                              : ''
                          "
                        ></i>
                      </span>
                    </div>
                  </van-col>
                </van-row>
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 分割线 -->
        <div class="parting-line"></div>
        <!-- 技术面 -->
        <!-- 技术面标题 -->
        <div class="marginBottom8">
          <!-- 1级分类标题 -->
          <div class="title-class-info">
            <div class="title-left-class">技术</div>
            <div class="title-centre-class">
              <span class="title-centre-text-lable">调优前</span>
              <span class="title-centre-text-num">{{
                yzData.TechData ? yzData.TechData.FenShu : '--'
              }}</span>
              <span class="title-centre-text-lable">调优后</span>
              <span class="title-centre-text-num">{{
                tyData.TechData ? tyData.TechData.FenShu : '--'
              }}</span>
              <span>
                <i
                  :class="
                    tyData.TechData
                      ? yzData.TechData.FenShu > tyData.TechData.FenShu
                        ? 'downArrow'
                        : yzData.TechData.FenShu < tyData.TechData.FenShu
                        ? 'topArrow'
                        : ''
                      : ''
                  "
                ></i>
              </span>
            </div>
            <div class="title-right-class">
              <i
                class="helpGray"
                @click="
                  setTextMsgInfo(
                    '技术分数由当日股池中个股近期涨幅以及震荡、移动平均线等相关技术指标综合计算得出。'
                  )
                "
              ></i>
            </div>
          </div>
        </div>
        <!-- 技术面描述 -->
        <div class="background-gray marginBottom16">
          调优后因子技术指标表现<span v-if="jsmLable1 == 1" class="textRedInfo">更强</span
          ><span v-else-if="jsmLable1 == 0">无明显提升</span
          ><span v-else class="textGreenInfo">更弱</span>，其中震荡指标<span
            v-if="tyData.TechData && tyData.TechData.ZdLable == 1"
            class="textRedInfo"
            >较强势</span
          ><span v-else-if="tyData.TechData && tyData.TechData.ZdLable == 0">中性</span
          ><span v-else class="textGreenInfo">较弱势</span>，均线指标<span
            v-if="tyData.TechData && tyData.TechData.MaLable == 1"
            class="textRedInfo"
            >较强势</span
          ><span v-else-if="tyData.TechData && tyData.TechData.MaLable == 0">中性</span
          ><span v-else class="textGreenInfo">较弱势</span>。<span v-if="tyData.TechData && tyData.TechData.ZhangFuDaYu5Cnt">信号池中{{ tyData.TechData ? tyData.TechData.ZhangFuDaYu5Cnt : 0 }}个股今日涨幅超过5%。</span>
        </div>
        <!-- 技术数据分析标题 -->
        <div class="title-second-order marginBottom8">技术数据分析</div>
        <!-- 技术数据分析(调优前) -->
        <div class="title-fourth-order marginBottom8">调优前</div>
        <div class="background-gray marginBottom8">
          <div>
            <van-row class="marginBottom8">
              <van-col span="8" class="jsfx-top-text jsfx-left-text">较弱势</van-col>
              <van-col span="8" class="jsfx-top-text jsfx-centre-text">中立</van-col>
              <van-col span="8" class="jsfx-top-text jsfx-right-text">较强势</van-col>
            </van-row>
            <!-- 技术分析进度条 -->
            <van-row gutter="4" class="marginBottom8">
              <van-col span="8">
                <div class="jsfx-div-left"></div>
              </van-col>
              <van-col span="8">
                <div class="jsfx-div-center"></div>
              </van-col>
              <van-col span="8">
                <div class="jsfx-div-right"></div>
              </van-col>
            </van-row>
            <!-- 技术分析箭头 -->
            <van-row>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="yzData.TechData && yzData.TechData.FinalLable == -1"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="yzData.TechData && yzData.TechData.FinalLable == 0"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="yzData.TechData && yzData.TechData.FinalLable == 1"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
            </van-row>
            <!-- 技术分析-股票数量 -->
            <van-row>
              <van-col span="8" class="jsfx-bottom-text jsfx-left-text">
                <span class="jsfx-bottom-icon-left"></span>较弱势{{
                  yzData.TechData ? yzData.TechData.StockFenBu[0] : 0
                }}只
              </van-col>
              <van-col span="8" class="jsfx-bottom-text jsfx-centre-text">
                <span class="jsfx-bottom-icon-center"></span>中立{{
                  yzData.TechData ? yzData.TechData.StockFenBu[1] : 0
                }}只
              </van-col>
              <van-col span="8" class="jsfx-bottom-text jsfx-right-text">
                <span class="jsfx-bottom-icon-right"></span>较强势{{
                  yzData.TechData ? yzData.TechData.StockFenBu[2] : 0
                }}只
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 技术数据分析(调优后) -->
        <div class="title-fourth-order marginBottom8">调优后</div>
        <div class="background-gray marginBottom8">
          <div>
            <van-row class="marginBottom8">
              <van-col span="8" class="jsfx-top-text jsfx-left-text">较弱势</van-col>
              <van-col span="8" class="jsfx-top-text jsfx-centre-text">中立</van-col>
              <van-col span="8" class="jsfx-top-text jsfx-right-text">较强势</van-col>
            </van-row>
            <!-- 技术分析进度条 -->
            <van-row gutter="4" class="marginBottom8">
              <van-col span="8">
                <div class="jsfx-div-left"></div>
              </van-col>
              <van-col span="8">
                <div class="jsfx-div-center"></div>
              </van-col>
              <van-col span="8">
                <div class="jsfx-div-right"></div>
              </van-col>
            </van-row>
            <!-- 技术分析箭头 -->
            <van-row>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="tyData.TechData && tyData.TechData.FinalLable == -1"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="tyData.TechData && tyData.TechData.FinalLable == 0"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  class="jsfx-centre-text"
                  v-if="tyData.TechData && tyData.TechData.FinalLable == 1"
                >
                  <i class="pointerIcon"></i>
                </div>
              </van-col>
            </van-row>
            <!-- 技术分析-股票数量 -->
            <van-row>
              <van-col span="8" class="jsfx-bottom-text jsfx-left-text">
                <span class="jsfx-bottom-icon-left"></span>较弱势{{
                  tyData.TechData ? tyData.TechData.StockFenBu[0] : 0
                }}只
              </van-col>
              <van-col span="8" class="jsfx-bottom-text jsfx-centre-text">
                <span class="jsfx-bottom-icon-center"></span>中立{{
                  tyData.TechData ? tyData.TechData.StockFenBu[1] : 0
                }}只
              </van-col>
              <van-col span="8" class="jsfx-bottom-text jsfx-right-text">
                <span class="jsfx-bottom-icon-right"></span>较强势{{
                  tyData.TechData ? tyData.TechData.StockFenBu[2] : 0
                }}只
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 调优后强势个股标题 -->
        <div
          class="title-second-order marginBottom8"
          v-if="tyData.TechData && tyData.TechData.StockList.length > 0"
        >
          调优后强势个股
        </div>
        <!-- 强势个股数据 -->
        <div v-if="tyData.TechData && tyData.TechData.StockList.length > 0">
          <van-row gutter="8">
            <van-col span="24">
              <div
                :class="
                  tyData.TechData
                    ? tyData.TechData.StockList[0].Value > 0
                      ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.TechData.StockList[0].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.TechData ? tyData.TechData.StockList[0].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{ formatStock(tyData.TechData ? tyData.TechData.StockList[0].StockCode : null) }}
                </div>
              </div>
               
                <div class="stock-red-zhangfu">
                  <span>今日涨幅</span>
                  <span class="stock-zhangfu-num">{{
                    toFixedNum(
                      tyData.TechData ? tyData.TechData.StockList[0].Value * 100 : null,
                      2,
                      '%'
                    )
                  }}</span>
                </div>
              </div>
            </van-col>
            <van-col span="24" v-if="tyData.TechData && tyData.TechData.StockList.length > 1">
              <div
                :class="
                  tyData.TechData
                    ? tyData.TechData.StockList[1].Value > 0
                    ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.TechData.StockList[1].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.TechData ? tyData.TechData.StockList[1].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{ formatStock(tyData.TechData ? tyData.TechData.StockList[1].StockCode : null) }}
                </div>
              </div>
                
                <div class="stock-red-zhangfu">
                  <span>今日涨幅</span>
                  <span class="stock-zhangfu-num">{{
                    toFixedNum(
                      tyData.TechData ? tyData.TechData.StockList[1].Value * 100 : null,
                      2,
                      '%'
                    )
                  }}</span>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <!-- 分割线 -->
        <div class="parting-line"></div>
        <!-- 基本面 -->
        <!-- 基本面标题 -->
        <div class="marginBottom8">
          <!-- 1级分类标题 -->
          <div class="title-class-info">
            <div class="title-left-class">基本</div>
            <div class="title-centre-class">
              <span class="title-centre-text-lable">调优前</span>
              <span class="title-centre-text-num">{{
                yzData.BasicData ? yzData.BasicData.FenShu : '--'
              }}</span>
              <span class="title-centre-text-lable">调优后</span>
              <span class="title-centre-text-num">{{
                tyData.BasicData ? tyData.BasicData.FenShu : '--'
              }}</span>
              <span>
                <i
                  :class="
                    tyData.BasicData
                      ? yzData.BasicData.FenShu > tyData.BasicData.FenShu
                        ? 'downArrow'
                        : yzData.BasicData.FenShu < tyData.BasicData.FenShu
                        ? 'topArrow'
                        : ''
                      : ''
                  "
                ></i>
              </span>
            </div>
            <div class="title-right-class">
              <i
                class="helpGray"
                @click="
                  setTextMsgInfo(
                    '基本分数由净资产收益率、销售净利润率、资产周转率等10余项财务数据综合计算得出。'
                  )
                "
              ></i>
            </div>
          </div>
        </div>
        <!-- 基本面描述 -->
        <div class="background-gray marginBottom16">
          调优后基本面总得分<span v-if="jbmLable1 == 1"
            >有所<span class="textRedInfo">提升</span></span
          ><span v-else-if="jbmLable1 == 0">提升不大</span
          ><span v-else>有所<span class="textGreenInfo">下降</span></span
          >，<span v-if="jbmLable3 == ''">各方面能力提升效果均不佳，建议调整策略重新调优</span
          ><!--
		  --><span v-else>
            <span class="textBlueInfo">{{ jbmLable3 }}</span
            >{{ jbmLable2 }}</span
          >。<span v-if="jbmDescBool !== ''"
            >信号池中{{ toFixedNum(jbmDescBool * 100,2,'%') }}个股在机构评级中为{{ jbmDescBool2 }}，{{
              jbmDescBool3
            }}。</span
          >
        </div>
        <!-- 财务数据分析标题 -->
        <div class="title-second-order marginBottom8">财务数据分析</div>
        <!-- 财务数据雷达图 -->
        <div class="marginBottom8">
          <div class="radarEchars" id="caiWuRadar"></div>
        </div>
        <!-- 机构评级(近3月)标题 -->
        <div class="title-second-order marginBottom8">机构评级（近3月）</div>
        <!-- 机构评级近三月数据 -->
        <div>
          <van-row class="marginBottom8">
            <van-col span="6"></van-col>
            <van-col span="6" class="jsfx-right-text textGreenInfo font12Info">减持/卖出</van-col>
            <van-col span="6" class="jsfx-right-text textGray999Info font12Info">中性</van-col>
            <van-col span="6" class="jsfx-right-text textRedInfo font12Info">增持/买入</van-col>
          </van-row>
          <van-row class="marginBottom8">
            <van-col span="6" class="textGray999Info font14Info">调优前</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmYzMaiChuTongBi*100, 2, '%')
            }}</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmYzZhongXingTongBi*100, 2, '%')
            }}</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmYzMaiRuTongBi*100, 2, '%')
            }}</van-col>
          </van-row>
          <van-row class="marginBottom8">
            <van-col span="6" class="textGray999Info font14Info">调优后</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmTyMaiChuTongBi*100, 2, '%')
            }}</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmTyZhongXingTongBi*100, 2, '%')
            }}</van-col>
            <van-col span="6" class="jsfx-right-text font14Info textGray999Info">{{
              toFixedNum(jbmTyMaiRuTongBi*100, 2, '%')
            }}</van-col>
          </van-row>
        </div>
        <!-- 调优后强势个股标题 -->
        <div
          class="title-second-order marginBottom8"
          v-if="tyData.BasicData && tyData.BasicData.StockList.length > 0"
        >
          调优后强势个股
        </div>
        <!-- 强势个股数据 -->
        <div v-if="tyData.BasicData && tyData.BasicData.StockList.length > 0">
          <van-row gutter="8">
            <van-col span="24">
              <div
                :class="
                  tyData.BasicData
                    ? tyData.BasicData.StockList[0].Value > 0
                      ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.BasicData.StockList[0].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.BasicData ? tyData.BasicData.StockList[0].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{
                    formatStock(tyData.BasicData ? tyData.BasicData.StockList[0].StockCode : null)
                  }}
                </div>
              </div>
               
                <div class="stock-red-zhangfu">
                  <span>市盈率</span>
                  <span class="stock-zhangfu-num">{{
                    toFixedNum(
                      tyData.BasicData ? tyData.BasicData.StockList[0].Value : null,
                      2,
                      ''
                    )
                  }}</span>
                </div>
              </div>
            </van-col>
            <van-col span="24" v-if="tyData.BasicData && tyData.BasicData.StockList.length > 1">
              <div
                :class="
                  tyData.BasicData
                    ? tyData.BasicData.StockList[1].Value > 0
                      ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.BasicData.StockList[1].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.BasicData ? tyData.BasicData.StockList[1].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{
                    formatStock(tyData.BasicData ? tyData.BasicData.StockList[1].StockCode : null)
                  }}
                </div>
              </div>
               
                <div class="stock-red-zhangfu">
                  <span>市盈率</span>
                  <span class="stock-zhangfu-num">{{
                    toFixedNum(
                      tyData.BasicData ? tyData.BasicData.StockList[1].Value : null,
                      2,
                      ''
                    )
                  }}</span>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <!-- 分割线 -->
        <div class="parting-line"></div>
        <!-- 资金面 -->
        <!-- 资金面标题 -->
        <div class="marginBottom8">
          <!-- 1级分类标题 -->
          <div class="title-class-info">
            <div class="title-left-class">资金</div>
            <div class="title-centre-class">
              <span class="title-centre-text-lable">调优前</span>
              <span class="title-centre-text-num">{{
                yzData.ZiJinData ? yzData.ZiJinData.FenShu : '--'
              }}</span>
              <span class="title-centre-text-lable">调优后</span>
              <span class="title-centre-text-num">{{
                tyData.ZiJinData ? tyData.ZiJinData.FenShu : '--'
              }}</span>
              <span>
                <i
                  :class="
                    tyData.ZiJinData
                      ? yzData.ZiJinData.FenShu > tyData.ZiJinData.FenShu
                        ? 'downArrow'
                        : yzData.ZiJinData.FenShu < tyData.ZiJinData.FenShu
                        ? 'topArrow'
                        : ''
                      : ''
                  "
                ></i>
              </span>
            </div>
            <div class="title-right-class">
              <i
                class="helpGray"
                @click="
                  setTextMsgInfo('资金分数由当日股池中个股近期资金流向及其他资金因子综合计算得出。')
                "
              ></i>
            </div>
          </div>
        </div>
        <!-- 资金面描述 -->
        <div class="background-gray marginBottom16">
          观察主力资金流向，今日主力资金净流入的信号占比<span v-if="zjmTiaoYouZhanBiShow"
            >从{{ toFixedNum(zjmYzZhanBi, 2, '%')
            }}<span v-if="zjmTiaoYouZhanBiShow2" class="textRedInfo">增加</span
            ><span v-else class="textGreenInfo">下降</span>到{{
              toFixedNum(zjmTyZhanBi, 2, '%')
            }} </span
          ><span v-else>不变</span> 。
        </div>
        <!-- 主力资金流向分布 -->
        <div class="title-second-order marginBottom8">主力资金流向分布</div>
        <!-- 主力资金流向分布(柱状图) -->
        <div class="marginBottom8">
          <div class="barEchars" id="barChartData"></div>
        </div>
        <!-- 调优后强势个股标题 -->
        <div
          class="title-second-order marginBottom8"
          v-if="tyData.ZiJinData && tyData.ZiJinData.StockList.length > 0"
        >
          调优后强势个股
        </div>
        <!-- 强势个股数据 -->
        <div v-if="tyData.ZiJinData && tyData.ZiJinData.StockList.length > 0">
          <van-row gutter="8">
            <van-col span="24">
              <div
                :class="
                  tyData.ZiJinData
                    ? tyData.ZiJinData.StockList[0].Value > 0
                      ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.ZiJinData.StockList[0].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.ZiJinData ? tyData.ZiJinData.StockList[0].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{
                    formatStock(tyData.ZiJinData ? tyData.ZiJinData.StockList[0].StockCode : null)
                  }}
                </div>
              </div>
                
                <div class="stock-red-zhangfu">
                  <span>净流入</span>
                  <span class="stock-zhangfu-num" >{{ process(tyData.ZiJinData ? tyData.ZiJinData.StockList[0].Value : null,2) }}</span>
                </div>
              </div>
            </van-col>
            <van-col span="24" v-if="tyData.ZiJinData && tyData.ZiJinData.StockList.length > 1">
              <div
                :class="
                  tyData.ZiJinData
                    ? tyData.ZiJinData.StockList[1].Value > 0
                    ? 'gegu-stock-newsRed gegu-stock-news'
                      : tyData.ZiJinData.StockList[1].Value < 0
                      ? 'gegu-stock-newsGreen gegu-stock-news'
                      : 'gegu-stock-newsGray gegu-stock-news'
                    : 'gegu-stock-newsGray gegu-stock-news'
                "
              >
              <div class="stock-info-left">
                <div class="stock-red-title">
                  {{ tyData.ZiJinData ? tyData.ZiJinData.StockList[1].StockName : '--' }}
                </div>
                <div class="stock-red-code">
                  {{
                    formatStock(tyData.ZiJinData ? tyData.ZiJinData.StockList[1].StockCode : null)
                  }}
                </div>
              </div>
                <div class="stock-red-zhangfu">
                  <span>净流入</span>
                  <span class="stock-zhangfu-num" >{{ process(tyData.ZiJinData ? tyData.ZiJinData.StockList[1].Value : null,2) }}</span>
                </div>
              </div>
            </van-col>
          </van-row>
        </div>
        <!-- 分割线 -->
        <div class="parting-line"></div>
        <!-- 题材面 -->
        <!-- 题材面标题 -->
        <div class="marginBottom8">
          <!-- 1级分类标题 -->
          <div class="title-class-info">
            <div class="title-left-class">题材</div>
            <div class="title-centre-class">
              <span class="title-centre-text-lable">调优前</span>
              <span class="title-centre-text-num">{{
                yzData.TiCaiData ? yzData.TiCaiData.FenShu : '--'
              }}</span>
              <span class="title-centre-text-lable">调优后</span>
              <span class="title-centre-text-num">{{
                tyData.TiCaiData ? tyData.TiCaiData.FenShu : '--'
              }}</span>
              <span>
                <i
                  :class="
                    tyData.TiCaiData
                      ? yzData.TiCaiData.FenShu > tyData.TiCaiData.FenShu
                        ? 'downArrow'
                        : yzData.TiCaiData.FenShu < tyData.TiCaiData.FenShu
                        ? 'topArrow'
                        : ''
                      : ''
                  "
                ></i>
              </span>
            </div>
            <div class="title-right-class">
              <i
                class="helpGray"
                @click="
                  setTextMsgInfo('题材分数由题材近期涨幅表现、涨停个股数量及其他题材因子计算得出。')
                "
              ></i>
            </div>
          </div>
        </div>
        <!-- 题材面描述 -->
        <div class="background-gray marginBottom16">
          {{ yzData.hq ? yzData.hq.FactorName : '--' }}因子相关行业为{{
            tcmHangYeText
          }}，调优后<span v-if="tyData.hq && tyData.hq.HangYeFenBu.length > 1">以{{ tyData.hq.HangYeFenBu[0].IndustryName }}行业为主。</span><span v-else>股票均为{{ tyData.hq?tyData.hq.HangYeFenBu[0].IndustryName:'--' }}行业。</span><span
            v-if="
              tyData.TiCaiData &&
              tyData.TiCaiData.LongTouList.length > 0 &&
              tyData.TiCaiData.LongTouList[0].HangYeZhangFu > 0
            "
            >{{ tyData.TiCaiData.LongTouList[0].HangYe }}行业为市场中热点概念，受关注度较高。</span
          >
        </div>
        <!-- 行业分布对比标题 -->
        <div class="title-second-order marginBottom8">行业分布对比</div>
        <!-- 行业分布图 -->
        <div class="marginBottom8">
          <div class="tb-height2">
            <div class="tb-chart" style="margin-right: 4px">
              <div class="hyfb-text">调优前</div>
              <div class="hyfb-chart" id="hyfbFront"></div>
            </div>
            <div class="tb-chart" style="margin-left: 4px">
              <div class="hyfb-text">调优后</div>
              <div class="hyfb-chart" id="hyfbBehind"></div>
            </div>
          </div>
        </div>
        <!-- 行业龙头个股 -->
        <!-- 调优后强势个股标题 -->
        <div
          class="title-second-order marginBottom8"
          v-if="tyData.TiCaiData && tyData.TiCaiData.LongTouList.length > 0"
        >
          行业龙头个股
        </div>
        <!-- 强势个股数据 -->
        <div v-if="tyData.TiCaiData && tyData.TiCaiData.LongTouList.length > 0">
          <van-row gutter="8">
            <van-col span="12">
              <div
                :class="
                  tyData.TiCaiData
                    ? tyData.TiCaiData.LongTouList[0].HangYeZhangFu > 0
                      ? 'gegulist-stock-red'
                      : tyData.TiCaiData.LongTouList[0].HangYeZhangFu < 0
                      ? 'gegulist-stock-green'
                      : 'gegulist-stock-gray'
                    : 'gegulist-stock-gray'
                "
              >
              <div class="top-stock-info">
                <div class="stock-title-info">
                  {{ tyData.TiCaiData ? tyData.TiCaiData.LongTouList[0].HangYe : '' }}
                </div>
                <div class="stock-zhangfu-info">
                  {{
                    toFixedNum(
                      tyData.TiCaiData ? tyData.TiCaiData.LongTouList[0].HangYeZhangFu * 100 : null,
                      2,
                      '%'
                    )
                  }}
                </div>
              </div>
                
                <div
                  class="stock-num-info"
                  v-for="(item, index) in tyData.TiCaiData.LongTouList[0].StockList"
                  :key="index"
                >
                  <van-row class="stock-flex-info">
                    <van-col span="12">
                      <div class="stock-name">{{ item.StockName }}</div>
                      <div class="stock-code">{{ formatStock(item.StockCode) }}</div>
                    </van-col>
                    <van-col span="12">
                      <div class="stock-zhangfu" :class="[judgeColor(item.Value)]" >{{ toFixedNum(item.Value * 100, 2, '%') }}</div>
                    </van-col>
                  </van-row>
                </div>
              </div>
            </van-col>
						<van-col span="12" v-if="tyData.TiCaiData && tyData.TiCaiData.LongTouList.length > 1" >
              <div
                :class="
                  tyData.TiCaiData
                    ? tyData.TiCaiData.LongTouList[1].HangYeZhangFu > 0
                      ? 'gegulist-stock-red'
                      : tyData.TiCaiData.LongTouList[1].HangYeZhangFu < 0
                      ? 'gegulist-stock-green'
                      : 'gegulist-stock-gray'
                    : 'gegulist-stock-gray'
                "
              >
              <div class="top-stock-info">
                <div class="stock-title-info">
                  {{ tyData.TiCaiData ? tyData.TiCaiData.LongTouList[1].HangYe : '' }}
                </div>
                <div class="stock-zhangfu-info">
                  {{
                    toFixedNum(
                      tyData.TiCaiData ? tyData.TiCaiData.LongTouList[1].HangYeZhangFu * 100 : null,
                      2,
                      '%'
                    )
                  }}
                </div>
              </div>
                <div
                  class="stock-num-info"
                  v-for="(item, index) in tyData.TiCaiData.LongTouList[1].StockList"
                  :key="index"
                >
                  <van-row class="stock-flex-info">
                    <van-col span="12">
                      <div class="stock-name">{{ item.StockName }}</div>
                      <div class="stock-code">{{ formatStock(item.StockCode) }}</div>
                    </van-col>
                    <van-col span="12">
                      <div class="stock-zhangfu" :class="[judgeColor(item.Value)]" >{{ toFixedNum(item.Value * 100, 2, '%') }}</div>
                    </van-col>
                  </van-row>
                </div>
              </div>
            </van-col>
          </van-row>
					
        </div>
        <!-- 分割线 -->
        <div class="parting-line"></div>
        <!-- 避雷面 -->
        <!-- 避雷面标题 -->
        <div class="marginBottom8">
          <!-- 1级分类标题 -->
          <div class="title-class-info">
            <div class="title-left-class">避雷</div>
            <div class="title-centre-class">
              <span class="title-centre-text-lable">调优前</span>
              <span class="title-centre-text-num">{{
                yzData.BiLeiData ? yzData.BiLeiData.FenShu : '--'
              }}</span>
              <span class="title-centre-text-lable">调优后</span>
              <span class="title-centre-text-num">{{
                tyData.BiLeiData ? tyData.BiLeiData.FenShu : '--'
              }}</span>
              <span>
                <i
                  :class="
                    tyData.BiLeiData
                      ? yzData.BiLeiData.FenShu > tyData.BiLeiData.FenShu
                        ? 'downArrow'
                        : yzData.BiLeiData.FenShu < tyData.BiLeiData.FenShu
                        ? 'topArrow'
                        : ''
                      : ''
                  "
                ></i>
              </span>
            </div>
            <div class="title-right-class">
              <i
                class="helpGray"
                @click="setTextMsgInfo('避雷分数由近期公告、今日舆情数据计算得出。')"
              ></i>
            </div>
          </div>
        </div>
        <!-- 避雷面描述 -->
        <div class="background-gray marginBottom16">
          调优后每只股票今日平均负面舆情数<span v-if="blmTextShow"
            >从{{ blmYzYuQingShu }}<span v-if="blmTextShow2" class="">上升</span
            ><span v-else class="">下降</span>到{{ blmTyYuQingShu }}</span
          ><span v-else>变化不大</span>。近期，公告方面<span v-if="blmLablesListShow">的风险有<span class="textRedInfo">{{ blmLablesText }}</span></span
          ><span v-else>无明显风险</span>。
        </div>
        <!-- 今日平均负面舆情数标题 -->
        <div class="title-second-order marginBottom8">今日平均负面舆情数</div>
        <!-- 强势个股数据 -->
        <div>
          <van-row gutter="8">
            <van-col span="12">
              <div class="gegulist-stock-gray">
                <div class="stock-title-info">{{ blmYzYuQingShu?blmYzYuQingShu:0 }}条/只</div>
                <div class="stock-fontSize12">调优前</div>
              </div>
            </van-col>
            <van-col span="12">
              <div class="gegulist-stock-gray">
                <div class="stock-title-info">{{ blmTyYuQingShu?blmTyYuQingShu:0 }}条/只</div>
                <div class="stock-fontSize12">调优后</div>
              </div>
            </van-col>
          </van-row>
        </div>
      </div>
      <div class="statement-info">
        免责声明：以上所有信息均通过公开信息收集汇总并由大数据工具自动计算得出，不代表本平台观点，结果仅供参考，亦不作为任何投资建议和买卖依据，若据此投资与本平台无关。
      </div>
    </div>

		<van-empty
      v-if="mnQuery"
      class="custom-image"
      :image="not_data"
      description="您查看的报告已失效,下次要早点来哦~"
    />

    <!-- 选择 -->
    <!-- <van-action-sheet
      v-model="sheetShow"
      :actions="sheetActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel"
      @select="onSheetSelect"
    /> -->
    <van-action-sheet v-model="sheetShow" 
    cancel-text="取消"
      close-on-click-action
      @cancel="onSheetCancel">
      <div class="content-sheet">
        <div v-for="(item,index) in sheetActions" :key="index" class="sheet-info" @click="onSheetSelect(index)" ><span class="sheet-title" :class="index==lshcMaxIndex?'sheet-title-select':''" >{{ item.name }}</span><span class="sheet-span" v-show="item.subname=='最优'" >最优</span> </div>
      </div>
    </van-action-sheet>
    <!-- 加载遮罩 -->
    <van-overlay :show="showLoading" @click="show = false">
      <div class="wrapper">
        <van-loading color="#1989fa" size="24px" vertical>数据加载中...</van-loading>
      </div>
    </van-overlay>
    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogTextShow"
      :message="dialogTextMsg"
      className="dialog_box"
      confirmButtonText="我知道了"
      @confirm="closeErrDialog()"
    >
    </van-dialog>

    <van-dialog
      v-model="dialogErrorMsg"
      :message="dialogErrorText"
      className="dialog_box"
      confirmButtonText="我知道了"
      @confirm="closeDialogInfo()"
    ></van-dialog>
  </div>
</template>

<script>
import { backtestAiReport, shareReportTow, getReportRedisById } from '@/api/report.js';
import {
  toFixedNum,
  judgeColor,
  formtTime,
  fangDouFun,
  getArrayIndex,
  formatStock,
  process
} from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  // 组件名称
  name: 'demo',
  mixins: [mixin],
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      // 单因子ID
      f_id: '',
      // 调优因子ID
      s_id: '',
      //   调优因子名称list
      s_name: '',
      // 报告时间
      bgTime: '',
      //   因子数据
      yzData: {},
      // 调优数据
      tyData: {},
      // 显示全部模版
      showMbInfo: false,
      //   调优参数列表
      nameArr: [],
      //   概述文字
      glxhsText: '',
      // 走势表现形式(1-优秀,3一般,2-欠佳)
      glzhBool: 0,
      // 短线涨幅
      dxZhangFuText: '',
      dxShengJiang: '',
      dxZhangFu1: 0,
      dxZhangFu2: 0,
      dx300TongBi: 0,
      // 长线涨幅
      cxZhangFuText: '',
      cxShengJiang: '',
      // 策略涨幅
      clText: '',
			// 长线数值
			cxMax:'',
      // 历史回测最优值
      lshcMaxIndex: 0,
      lshcFengGe: '',
      // 平均涨幅市场
      lshcZhangFUShiChang: '',
      // 历史上涨概率市场
      lshcShangZhangKaiLv: '',
      // 选择框
      sheetShow: false,
      sheetActions: [],
      // 当日股池描述
      drgcXinHaoShuLiang: '',
      // 当日股池总分表现
      drgcZongFenBiaoXian: '',
      // 表现分描述
      drgcTongBiText: '',
			drgcDataShow:false,
      // 技术面--描述1
      jsmLable1: 0,
      // 基本面 -- 描述1
      jbmLable1: 0,
      // 基本面 -- 描述2
      jbmLable2: '',
      jbmLable3: '',
      // 基本面 -- 机构评级数据
      jbmYzMaiChuTongBi: 0,
      jbmYzZhongXingTongBi: 0,
      jbmYzMaiRuTongBi: 0,
      jbmTyMaiChuTongBi: 0,
      jbmTyZhongXingTongBi: 0,
      jbmTyMaiRuTongBi: 0,
      // 基本面 -- 描述数据
      jbmDescBool: '',
      jbmDescBool2: '',
      jbmDescBool3: '',
      // 资金面 -- 描述数据
      zjmYzZhanBi: '',
      zjmTyZhanBi: '',
      zjmTiaoYouZhanBiShow: false,
      zjmTiaoYouZhanBiShow2: false,
      // 资金面 -- 柱状数据
      zjmYzStockZhanBiArr: [],
      zjmTyStockZhanBiArr: [],
      // 题材面
      tcmHangYeText: '',
      // 避雷面 - 描述数据
      blmLablesListShow: false,
      blmLablesText: '',
      blmTextShow: false,
      blmTextShow2: false,
      blmYzYuQingShu: '',
      blmTyYuQingShu: '',
      // classID (分享id)
      classId: '',
      // 分享状态值
      searchInfo: false,
      // 分享数据
      searchYzData: {},
      searchTyData: {},
      // 遮罩层
      showLoading: true,
      // 弹窗
      dialogTextShow: false,
      dialogTextMsg: '',
      // 错误弹窗
      dialogErrorMsg: false,
      dialogErrorText: '',
			// 失效
			mnQuery:false,
			not_data: require('../../assets/image/notData.png'),
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    judgeColor,
    toFixedNum,
    formatStock,
	process,
    // 获取所有数据
    getAllData: function () {
      Promise.all([this.getReportYzFunc(), this.getReportTyFunc()])
        .then((result) => {
          // 因子数据
          this.yzData = result[0];
          // console.log('🚀 ~ file: second.vue:80 ~ .then ~ this.yzData:', this.yzData);
          //   调优数据
          this.tyData = result[1];
          // console.log('this.tyData', this.tyData);
          this.renderAllData();
        })
        .catch((err) => {});
    },
    // 渲染所有数据
    renderAllData: function () {
      // 取消遮罩
      this.showLoading = false;
      // 补全数据
      if (this.tyData.TechData.StockList == undefined) {
        this.tyData.TechData.StockList = [];
      }
      if (this.tyData.ZiJinData.StockList == undefined) {
        this.tyData.ZiJinData.StockList = [];
      }
      if (this.tyData.TiCaiData.LongTouList == undefined) {
        this.tyData.TiCaiData.LongTouList = [];
      }

      //   生成报告的逻辑处理
      // 1.1 概述语句: 今日信号数判断 (if 今日信号数调优后数量下降) ps. 不会有今日信号数变多的情况
      let glxhsText = '';
      if (this.yzData.hq.XinHaoShuLiang > this.tyData.hq.XinHaoShuLiang) {
        glxhsText =
          '从' + this.yzData.hq.XinHaoShuLiang + '只下降到' + this.tyData.hq.XinHaoShuLiang + '只';
      } else {
        glxhsText = '不变';
      }
      this.glxhsText = glxhsText;
      //   1.2 组合整体表现值 调优后回测信息打标签 (优秀,一般,欠佳)
      let glzhBool = 0;
      if (
        this.tyData.backTest.ReportGradeResult.MaxRiseRate * 100 > 55 &&
        this.tyData.backTest.ReportGradeResult.BestAvgRate * 100 > 1
      ) {
        glzhBool = 1;
      } else if (
        this.tyData.backTest.ReportGradeResult.MaxRiseRate * 100 < 45 &&
        this.tyData.backTest.ReportGradeResult.BestAvgRate * 100 < 1
      ) {
        glzhBool = 2;
      } else {
        glzhBool = 3;
      }
      this.glzhBool = glzhBool;
      // 1.3 从短线看数据整合
      // 分别计算调优前后日、周涨幅变化率，计算方法为：[（1+调优后数据）/(1+调优前数据)]-1（结果需乘以100，转化为百分数形式，如计算结果为0.004，变化率为0.4%）
      // 日涨幅
      let yzRiZhangFu = this.setSyTongBi(
        this.yzData.hq.RiZhangFu * 100,
        this.tyData.hq.RiZhangFu
      );
			yzRiZhangFu = yzRiZhangFu=='--'?0:yzRiZhangFu;
      // 周涨幅数据
      let yzZhouZhangFu =this.setSyTongBi(
        this.yzData.hq.ZhangFu5,
        this.tyData.hq.ZhangFu5
      );
			yzZhouZhangFu = yzZhouZhangFu=='--'?0:yzZhouZhangFu;

      // 日涨幅变化率 ≥ 周涨幅变化率
      let dxZhangFuText = '';
      let dxShengJiang = '';
      let dxMax = 0;
      if (yzRiZhangFu!==0 && ((1+yzRiZhangFu *100) >= (1+yzZhouZhangFu*100))) {
        dxMax = yzRiZhangFu;
        dxZhangFuText = '日';
        if (yzRiZhangFu == 0) {
          dxShengJiang = '';
        } else {
          // 判断是上升还是下降
          if (this.yzData.hq.RiZhangFu > this.tyData.hq.RiZhangFu) {
            dxShengJiang = 'down';
          } else {
            dxShengJiang = 'up';
          }
        }
        this.dxZhangFu1 = this.toFixedNum(this.yzData.hq.RiZhangFu * 100, 2, '%');
        this.dxZhangFu2 = this.toFixedNum(this.tyData.hq.RiZhangFu * 100, 2, '%');
      } else {
				dxMax = yzZhouZhangFu;
        dxZhangFuText = '周';
        if (yzZhouZhangFu == 0) {
          dxShengJiang = '';
        } else {
          // 判断是上升还是下降
          if (this.yzData.hq.ZhangFu5 > this.tyData.hq.ZhangFu5) {
            dxShengJiang = 'down';
          } else {
            dxShengJiang = 'up';
          }
        }
        this.dxZhangFu1 = this.toFixedNum(this.yzData.hq.ZhangFu5, 2, '%');
        this.dxZhangFu2 = this.toFixedNum(this.tyData.hq.ZhangFu5, 2, '%');
      }
      this.dxZhangFuText = dxZhangFuText;
      this.dxShengJiang = dxShengJiang;
      // 1.4  计算A处涨幅（即日涨幅或周涨幅）与同期大盘涨幅的变化率（设rate_baseline），
      // 计算方式为：[（1+X涨幅）/(1+沪深300的X涨幅)]-1 (调优后)
      // (结果需乘以100，转化为百分数形式，如计算结果为0.004，变化率为0.4%），结果保留两位小数
      let dx300TongBi = '';
      if (yzRiZhangFu >= yzZhouZhangFu) {
        // 日涨幅
        dx300TongBi = Number(
          ((1 + this.tyData.hq.RiZhangFu) / (1 + this.yzData.hushen300.RiZhangFu) - 1) * 100
        ).toFixed(2);
      } else {
        dx300TongBi = Number(
          (1 + this.tyData.hq.ZhangFu5) / (1 + this.yzData.hushen300.ZhangFu5) - 1
        ).toFixed(2);
      }
			if(isNaN(dx300TongBi)) {
				dx300TongBi = 0;
			}
      this.dx300TongBi = dx300TongBi;
      // 1.5 长期数据整合
      // 半年涨幅(同比)
      let yzBanNianZhangFu = this.setSyTongBi(
        this.yzData.hq.ZhangFu180,
        this.tyData.hq.ZhangFu180
      );
      // 年涨幅(同比)
      let yzNianZhangFu =this.setSyTongBi(
        this.yzData.hq.ZhangFu360,
        this.tyData.hq.ZhangFu360
      );
      let cxShengJiang = '';
      let cxZhangFuText = '';
      let cxMax = 0;
			
      if ((1+yzBanNianZhangFu/100) >= (1+yzNianZhangFu/100)) {
        cxMax = yzBanNianZhangFu;
        // 近半年涨幅
        cxZhangFuText = '近半年';
        if (yzBanNianZhangFu == 0) {
          cxShengJiang = '';
        } else if (yzBanNianZhangFu > 0) {
          cxShengJiang = 'up';
        } else {
          cxShengJiang = 'down';
        }
      } else {
        cxMax = yzNianZhangFu;
        // 近一年涨幅
        cxZhangFuText = '近一年';
        if (yzNianZhangFu == 0.0) {
          cxShengJiang = '';
        } else if (yzNianZhangFu > 0) {
          cxShengJiang = 'up';
        } else {
          cxShengJiang = 'down';
        }
      }
      this.cxZhangFuText = cxZhangFuText;
      this.cxShengJiang = cxShengJiang;
      // 1.6 策略数据集合
      let clText = '';
      if ((dxMax > 0) & (cxMax > 0) & (dxMax >= cxMax)) {
        // 短线最佳
        clText = '短线';
      } else if ((dxMax > 0) & (cxMax > 0) & (dxMax < cxMax)) {
        // 长线最佳
        clText = '长线';
      } else {
        clText = '';
      }
      this.clText = clText;
			this.cxMax = cxMax;
      // 1.7 折线图数据
      this.renderZs();
      // 2.1 获取最优参数
      let maxIndex = this.computeJdtjFunc();
      this.lshcMaxIndex = maxIndex;
      if (maxIndex + 1 == 1 || maxIndex + 1 == 2) {
        this.lshcFengGe = '超短线';
      } else if (maxIndex + 1 == 3) {
        this.lshcFengGe = '短线';
      } else {
        this.lshcFengGe = '中线';
      }
      // 2.2 根据最优值平均涨幅计算市场
      let lshcZhangFUShiChang = '';
      if (this.tyData.backTest.BacktestAnalysisResult[maxIndex].AvgSectionRate * 100 >= 3) {
        lshcZhangFUShiChang = '亮眼';
      } else if (this.tyData.backTest.BacktestAnalysisResult[maxIndex].AvgSectionRate * 100 >= 0) {
        lshcZhangFUShiChang = '偏稳健';
      } else {
        lshcZhangFUShiChang = '一般';
      }
      this.lshcZhangFUShiChang = lshcZhangFUShiChang;

      // 2.3 根据最优值历史上涨概率计算
      let lshcShangZhangKaiLv = '';
      if (this.tyData.backTest.BacktestAnalysisResult[maxIndex].RiseProbability * 100 >= 60) {
        lshcShangZhangKaiLv = '较为乐观';
      } else {
        lshcShangZhangKaiLv = '不够乐观';
      }
      this.lshcShangZhangKaiLv = lshcShangZhangKaiLv;

      // 2.4 持股周期
      // 处理下拉框数据
      this.sheetActions = this.yzData.backTest.BacktestAnalysisResult.map((item,index) => {
        let obj = {
          name: '持股' + item.HoldPeriod + '天',
          color:this.lshcMaxIndex==index?'#286DF7':'#555555',
          subname:maxIndex==index?'最优':'',
        };
        return obj;
      });

      // 3.1 当日股池对比描述
      // 判断调优前后的今日信号数
      let drgcXinHaoShuLiang = '';
      if (this.yzData.hq.XinHaoShuLiang > this.tyData.hq.XinHaoShuLiang) {
        drgcXinHaoShuLiang =
          '从' + this.yzData.hq.XinHaoShuLiang + '只下降到' + this.tyData.hq.XinHaoShuLiang + '只';
      } else {
        drgcXinHaoShuLiang = '不变';
      }
      this.drgcXinHaoShuLiang = drgcXinHaoShuLiang;

      // 3.1.B 计算总分 (调优后总分 == 调优前总分,一般) (调优后总分 ＞ 调优前总分,更佳) (欠佳)
      let drgcZongFenBiaoXian = '';
      if (this.yzData.zongFen == this.tyData.zongFen) {
        drgcZongFenBiaoXian = '一般';
      } else if (this.tyData.zongFen > this.yzData.zongFen) {
        drgcZongFenBiaoXian = '更佳';
      } else {
        drgcZongFenBiaoXian = '欠佳';
      }
      this.drgcZongFenBiaoXian = drgcZongFenBiaoXian;

      // 3.1.C  计算调优前后五个子维度的变化百分比
      //  五个变化百分比都为负 => 各方面均无明显提高
      // 维度计算公式 : (调优后的分数-调优前的分数)/调优前的分数
      // 技术面的同比分数
      let subsetTongBi = [];
      subsetTongBi[0] = this.setSyTongBi(this.yzData.TechData.FenShu, this.tyData.TechData.FenShu);
      // 基本面的同比分数
      subsetTongBi[1] = this.setSyTongBi(
        this.yzData.BasicData.FenShu,
        this.tyData.BasicData.FenShu
      );
      // 资金面的同比分数
      subsetTongBi[2] = this.setSyTongBi(
        this.yzData.ZiJinData.FenShu,
        this.tyData.ZiJinData.FenShu
      );
      // 题材面的同比分数
      subsetTongBi[3] = this.setSyTongBi(
        this.yzData.TiCaiData.FenShu,
        this.tyData.TiCaiData.FenShu
      );
      // 避雷面的同比分数
      subsetTongBi[4] = this.setSyTongBi(
        this.yzData.BiLeiData.FenShu,
        this.tyData.BiLeiData.FenShu
      );
      let drgcTongBiText = '';
      if (
        subsetTongBi[0] > 0 ||
        subsetTongBi[1] > 0 ||
        subsetTongBi[2] > 0 ||
        subsetTongBi[3] > 0 ||
        subsetTongBi[4] > 0
      ) {
        drgcTongBiText = '面提高较为明显';
        // 查询变化百分比最大的维度 , 如果有多个维度变化百分比相同且都为最大用顿号隔开
        let max = Math.max(...subsetTongBi);
				max = max.toFixed(2);
        let maxKey = subsetTongBi.indexOf(max + '');
        let setTextArr = ['技术', '基本', '资金', '题材', '避雷'];
        drgcTongBiText = setTextArr[maxKey] + drgcTongBiText;
      } else {
        drgcTongBiText = '各方面均无明显提高';
      }
      this.drgcTongBiText = drgcTongBiText;
			// 判断调优后
			if(this.tyData.TodayPoolData.ZhangTingCnt > 0 || this.tyData.TodayPoolData.LianBanCnt > 0 || this.tyData.TodayPoolData.QiangShiCnt > 0 || this.tyData.TodayPoolData.DuanQiXinGaoCnt > 0 || this.tyData.TodayPoolData.longHuBangCnt > 0) {
				this.drgcDataShow = true;
			} else {
				this.drgcDataShow = false;
			}

      // 3.1 执行雷达图数据
      this.setRadar();
      // 4.1 技术面
      // 调优后总标签强于调优前总标签 => 更强, 调优后总标签==调优前总标签 => 无明显提升 , 更弱
      // jsmLable1(1=>更强, 0=>无明显提升, -1=>更弱)
      let jsmLable1 = '';
      if (this.tyData.TechData.FinalLable > this.yzData.TechData.FinalLable) {
        jsmLable1 = 1;
      } else if (this.tyData.TechData.FinalLable == this.yzData.TechData.FinalLable) {
        jsmLable1 = 0;
      } else {
        jsmLable1 = -1;
      }
      // 5.1 基本面 - 执行技术面雷达图
      // 基本面描述
      let jbmLable1 = 0;
      if (this.tyData.BasicData.FenShu > this.yzData.BasicData.FenShu) {
        jbmLable1 = 1;
      } else if (this.tyData.BasicData.FenShu == this.yzData.BasicData.FenShu) {
        jbmLable1 = 0;
      } else {
        jbmLable1 = -1;
      }
      this.jbmLable1 = jbmLable1;
      // 5.2 基本面 - B - 描述
      let jbmLable2 = '';
      let jbmLable3 = '';
      // 设置5个维度
      let jbmSetTongBi = [];
      // 成长能力
      jbmSetTongBi[0] = this.setSyTongBi(
        this.yzData.BasicData.ChengZhangNengLi,
        this.tyData.BasicData.ChengZhangNengLi
      );
      // 盈利能力
      jbmSetTongBi[1] = this.setSyTongBi(
        this.yzData.BasicData.YingLiNengLi,
        this.tyData.BasicData.YingLiNengLi
      );
      // 营运能力
      jbmSetTongBi[2] = this.setSyTongBi(
        this.yzData.BasicData.YunYingNengLi,
        this.tyData.BasicData.YunYingNengLi
      );
      // 偿债能力
      jbmSetTongBi[3] = this.setSyTongBi(
        this.yzData.BasicData.ChangZhaiNengLi,
        this.tyData.BasicData.ChangZhaiNengLi
      );
      // 现金流
      jbmSetTongBi[4] = this.setSyTongBi(
        this.yzData.BasicData.XianJinLiu,
        this.tyData.BasicData.XianJinLiu
      );
      if (
        jbmSetTongBi[0] > 0 ||
        jbmSetTongBi[1] > 0 ||
        jbmSetTongBi[2] > 0 ||
        jbmSetTongBi[3] > 0 ||
        jbmSetTongBi[4] > 0
      ) {
        // 查询变化百分比最大的维度 , 如果有多个维度变化百分比相同且都为最大用顿号隔开
        let maxJbm = Math.max(...jbmSetTongBi);
        maxJbm = maxJbm.toFixed(2);
        let maxJbmKey = jbmSetTongBi.indexOf(maxJbm + '');
        let setJbmTextArr = ['成长能力', '盈利能力', '营运能力', '偿债能力', '现金流'];
        let setJbmDescArr = [
          '方面提升较为明显，市场对股池中个股的发展潜力有较好的预期',
          '方面提升较为明显，股池中个股的企业经营效益较好',
          '方面提升较为明显，股池中个股的企业运营和管理水平被较为看好',
          '方面提升较为明显，股池中个股的企业财务状况和经营能力较好',
          '方面提升较为明显，股池中个股的资金周转能力被较为看好'
        ];
        jbmLable2 = setJbmDescArr[maxJbmKey];
        jbmLable3 = setJbmTextArr[maxJbmKey];
      } else {
        jbmLable2 = '各方面能力提升效果均不佳，建议调整策略重新调优';
      }
      this.jbmLable2 = jbmLable2;
      this.jbmLable3 = jbmLable3;
      // 5.5 机构评级近3个月数据计算 (调优前,调优后)
      // 调优前 (减持/卖出 百分比计算公式: (减持+卖出)/信号数 )
      let jbmYzMaiChuTongBi =
        (this.yzData.BasicData.JianChi + this.yzData.BasicData.MaiChu) /
        this.yzData.hq.XinHaoShuLiang;
      let jbmYzZhongXingTongBi = this.yzData.BasicData.ZhongXing / this.yzData.hq.XinHaoShuLiang;
      let jbmYzMaiRuTongBi =
        (this.yzData.BasicData.ZengChi + this.yzData.BasicData.MaiRu) /
        this.yzData.hq.XinHaoShuLiang;
      // 调优后
      let jbmTyMaiChuTongBi =
        (this.tyData.BasicData.JianChi + this.tyData.BasicData.MaiChu) /
        this.tyData.hq.XinHaoShuLiang;
      let jbmTyZhongXingTongBi = this.tyData.BasicData.ZhongXing / this.tyData.hq.XinHaoShuLiang;
      let jbmTyMaiRuTongBi =
        (this.tyData.BasicData.ZengChi + this.tyData.BasicData.MaiRu) /
        this.tyData.hq.XinHaoShuLiang;
      this.jbmYzMaiChuTongBi = jbmYzMaiChuTongBi;
      this.jbmYzZhongXingTongBi = jbmYzZhongXingTongBi;
      this.jbmYzMaiRuTongBi = jbmYzMaiRuTongBi;
      this.jbmTyMaiChuTongBi = jbmTyMaiChuTongBi;
      this.jbmTyZhongXingTongBi = jbmTyZhongXingTongBi;
      this.jbmTyMaiRuTongBi = jbmTyMaiRuTongBi;
      // 基本面描述 5.4 描述
      let jbmDescBool = '';
			let jbmDescBool2  = '';
			let jbmDescBool3 = '';
      if (
        this.jbmTyMaiChuTongBi > 0 ||
        this.jbmTyZhongXingTongBi > 0 ||
        this.jbmTyMaiRuTongBi > 0
      ) {
        // 三个值赋值到数组中
        let jbmTyDataArr = [];
        jbmTyDataArr[0] = this.jbmTyMaiChuTongBi;
        jbmTyDataArr[1] = this.jbmTyZhongXingTongBi;
        jbmTyDataArr[2] = this.jbmTyMaiRuTongBi;
        // 获取三个中的最大值
        let maxTyJbm = Math.max(...jbmTyDataArr);
				let setMaxIndexJmb = jbmTyDataArr.map((item) => item).indexOf(maxTyJbm);
        let setJbmTyTextArr = ['减持/卖出', '中性', '增持/买入'];
        jbmDescBool = jbmTyDataArr[setMaxIndexJmb];
        jbmDescBool2 = setJbmTyTextArr[setMaxIndexJmb];
        if (jbmDescBool == jbmTyDataArr[2]) {
          jbmDescBool3 = '市场对未来前景较为乐观';
        } else {
          jbmDescBool3 = '市场对未来前景不够乐观';
        }
      } else {
        jbmDescBool = '';
      }
			this.jbmDescBool = jbmDescBool;
			this.jbmDescBool2 = jbmDescBool2;
			this.jbmDescBool3 = jbmDescBool3;

      this.setCaiWuRadar();
      // 6.1 资金面
      // 调优前的资金占比 :  股票个数 / 今日信号数
      let zjmYzZhanBi = Number(
        (this.yzData.ZiJinData.ZiJinJingLiuRuGeShu / this.yzData.hq.XinHaoShuLiang) * 100
      ).toFixed(2);
      this.zjmYzZhanBi = zjmYzZhanBi;
      // 调优后偶的资金占比
      let zjmTyZhanBi = Number(
        (this.tyData.ZiJinData.ZiJinJingLiuRuGeShu / this.tyData.hq.XinHaoShuLiang) * 100
      ).toFixed(2);
      this.zjmTyZhanBi = zjmTyZhanBi;
      // 判断调优前后的资金占比
      let zjmTiaoYouZhanBiShow = false;
      let zjmTiaoYouZhanBiShow2 = false;
      if (zjmYzZhanBi == zjmTyZhanBi) {
        zjmTiaoYouZhanBiShow = false;
      } else {
        zjmTiaoYouZhanBiShow = true;
        if (zjmTyZhanBi*1 > zjmYzZhanBi*1) {
          // 增加到
          zjmTiaoYouZhanBiShow2 = true;
        } else {
          // 减少到
          zjmTiaoYouZhanBiShow2 = false;
        }
      }
      this.zjmTiaoYouZhanBiShow = zjmTiaoYouZhanBiShow;
      this.zjmTiaoYouZhanBiShow2 = zjmTiaoYouZhanBiShow2;
      // 6.2 资金面 - 柱状图
      // 计算调优前的占比
      let zjmYzStockNumArr = this.yzData.ZiJinData.ZiJinLiuXiangFenBu.split(',').map(Number);
      let zjmYzStockNumSum = zjmYzStockNumArr.reduce((a, b) => a + b, 0);
      let zjmYzStockZhanBiArr = zjmYzStockNumArr.map((item) => {
        return Number((item / zjmYzStockNumSum) * 100).toFixed(2);
      });
      this.zjmYzStockZhanBiArr = zjmYzStockZhanBiArr;
      // 计算调优后占比
      let zjmTyStockNumArr = this.tyData.ZiJinData.ZiJinLiuXiangFenBu.split(',').map(Number);
      let zjmTyStockNumSum = zjmTyStockNumArr.reduce((a, b) => a + b, 0);
      let zjmTyStockZhanBiArr = zjmTyStockNumArr.map((item) => {
        return Number((item / zjmTyStockNumSum) * 100).toFixed(2);
      });
      this.zjmTyStockZhanBiArr = zjmTyStockZhanBiArr;
      // 渲染柱状图
      this.setBarChartData();

      // 7.1 题材
      this.renderHyfb();
      this.renderHyfb2();
      // 7.2 题材描述
      // 获取调优前头部行业
      let tcmHangYeList = this.yzData.hq.HangYeFenBu;
      let tcmHangYeText = '';
      if (tcmHangYeList.length > 0) {
        if (tcmHangYeList.length > 3) {
          tcmHangYeList.forEach((item, index) => {
            if (index < 3) {
              tcmHangYeText = tcmHangYeText + item.IndustryName + '，';
            }
          });
        } else {
          tcmHangYeList.forEach((item, index) => {
            tcmHangYeText = tcmHangYeText + item.IndustryName + '，';
          });
        }
      } else {
        tcmHangYeText = '无';
      }
      tcmHangYeText = tcmHangYeText.slice(0, -1);
      
	  if (tcmHangYeList.length > 3)  {
		tcmHangYeText = tcmHangYeText+'等';
	  }
	  
      this.tcmHangYeText = tcmHangYeText;

      // 8.0 避雷数据
      // 8.1 避雷描述
      let blmLablesArr = this.tyData.BiLeiData.FengXianLables;
      let blmLablesListShow = false;
      let blmLablesText = '';
      if (blmLablesArr && blmLablesArr.length > 0) {
        if (blmLablesArr.length > 3) {
          blmLablesText = blmLablesArr.slice(0, 3).join('，') + '等';
        } else {
          blmLablesText = blmLablesArr.join('，');
        }
        blmLablesListShow = true;
      } else {
        blmLablesListShow = false;
      }
			
      this.blmLablesText = blmLablesText;
      this.blmLablesListShow = blmLablesListShow;
      // 8.2 获取调优前后的占比
			
      let blmYzYuQingShu = Number((this.yzData.yqNumber / this.yzData.hq.XinHaoShuLiang)).toFixed(2);
      let blmTyYuQingShu = Number((this.tyData.yqNumber / this.tyData.hq.XinHaoShuLiang)).toFixed(2);
      this.blmYzYuQingShu = blmYzYuQingShu;
      this.blmTyYuQingShu = blmTyYuQingShu;
      //
      let blmTextShow = false;
      let blmTextShow2 = false;
      if (blmYzYuQingShu == blmTyYuQingShu) {
        blmTextShow = false;
      } else {
        blmTextShow = true;
        // 调优后今日平均负面舆情数 > 调优前今日平均负面舆情数
        if (blmTyYuQingShu * 1 > blmYzYuQingShu * 1) {
          blmTextShow2 = true;
        } else {
          blmTextShow2 = false;
        }
      }
      this.blmTextShow = blmTextShow;
      this.blmTextShow2 = blmTextShow2;
    },
    // 获取普通因子的调优报告
    getReportYzFunc: function () {
      return new Promise((resolve, reject) => {
        let params = {
          factorID: this.f_id,
          type: 'yz'
        };
        backtestAiReport(params)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data);
            } else {
			  			this.dialogErrorMsg = true;
              this.dialogErrorText = '历史信号数量过少，统计结果不够全面，暂不支持查看报告，请修改条件后再次尝试';
              reject(result.msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 获取调优之后的调优报告
    getReportTyFunc: function () {
      return new Promise((resolve, reject) => {
        let params = {
          factorID: this.s_id,
          type: 'cl'
        };
        backtestAiReport(params)
          .then((result) => {
            if (result.err == 200) {
              resolve(result.data);
            } else {
              this.dialogErrorMsg = true;
              this.dialogErrorText = '历史信号数量过少，统计结果不够全面，暂不支持查看报告，请修改条件后再次尝试';
              reject(result.msg);
            }
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    // 调优参数下拉
    showMbName: function () {
      this.showMbInfo = !this.showMbInfo;
    },
    // 调优折线图数据
    renderZs: function () {
      var chartDom = document.getElementById('zssy');
      var myChart = this.$echarts.init(chartDom);
      let rawData = this.yzData.syfx.Tradday.length;
      var option;
      option = {
        tooltip: {
          trigger: 'axis',
          backgroundColor: 'rgba(107, 118, 135, 0.7)',
          borderWidth: 0,
          textStyle: {
            color: '#E4E9FE',
            fontSize: 12
          },
          axisPointer: {
            type: 'line',
            lineStyle: {
              type: 'solid'
            }
          },
          padding: [0, 0, 0, 0],
          position: function (point, params, dom, rect, size) {
            // 鼠标坐标和提示框位置的参考坐标系是：以外层div的左上角那一点为原点，x轴向右，y轴向下
            // 提示框位置
            var x = 0; // x坐标位置
            var y = 0; // y坐标位置

            // 当前鼠标位置
            var pointX = point[0];
            var pointY = point[1];

            // 外层div大小
            // var viewWidth = size.viewSize[0];
            // var viewHeight = size.viewSize[1];

            // 提示框大小
            var boxWidth = size.contentSize[0];
            var boxHeight = size.contentSize[1];

            // boxWidth > pointX 说明鼠标左边放不下提示框
            if (boxWidth > pointX) {
              x = 5;
            } else {
              // 左边放的下
              x = pointX - boxWidth;
            }

            // boxHeight > pointY 说明鼠标上边放不下提示框
            if (boxHeight > pointY) {
              y = 5;
            } else {
              // 上边放得下
              y = pointY - boxHeight;
            }

            return [x, y];
          },
          formatter: function (param) {
            var result = `<p style="font-size: 10px;margin-bottom: 2px;">日期: ${param[0].axisValue}</p>`;
            param.forEach((element, index) => {
              result += `<p style="font-size: 10px;margin-bottom: 2px;">${element.marker}${element.seriesName}</p>
	                             <p style="margin-bottom: 1px;">收益率：${element.value}% </p>`;
            });
            return result;
          }
        },
        legend: {
          data: ['调优前', '调优后', '沪深300'],
          icon: 'rect',
          itemWidth: 8,
          itemGap: 16,
          itemHeight: 3,
          itemWidth: 8,
          top: 0,
          textStyle: {
            color: '#999',
            fontSize: 12 // 文字的字体大小。
          }
        },
        color: ['#286DF7', '#FE7400', '#999999'],

        grid: {
          left: 10,
          top: 25,
          right: 10,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.yzData.syfx.Tradday,
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 900000000, //度标签的显示间隔 前一个标签和下一个标签的间隔
            showMaxLabel: true, //是否显示最大的
            margin: 13,
            align: 'center',

            formatter: function (value, index) {
              //给第一个标签 和 最后一个标签 增加标识 设置样式用
              let text = '';
              if (0 == index) {
                text = '{a|' + value + '}';
              }
              if (rawData - 1 == index) {
                text = '{b|' + value + '}';
              }
              return text;
            },
            rich: {
              //给标签文字设置样式 左右留出一些位置
              a: {
                padding: [0, 0, 0, 0]
              },
              b: {
                padding: [0, 0, 0, -50]
              }
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            position: 'left', //坐标轴位置，移至右边
            // name: '涨幅',
            splitLine: {
              lineStyle: {
                width: 0.5,
                // type: 'dashed',
                color: '#F0F0F0'
              }
            },
            axisLabel: {
              show: true,
              //Y轴数值可添加百分号
              formatter: '{value}%'
            }
          }
        ],
        series: [
          {
            name: '调优前',
            data: this.yzData.syfx.NetValue,
            type: 'line',
            smooth: true,
            showSymbol: false,
						lineStyle:{
							normal:{
								width:1,
							}
						},
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(40, 109, 247, 0.2)' },
                { offset: 0.3, color: 'rgba(40, 109, 247,0.1)' },
                { offset: 1, color: 'rgba(40, 109, 247,0)' }
              ])
            }
          },
          {
            name: '调优后',
            data: this.tyData.syfx.NetValue,
            type: 'line',
            smooth: true,
            showSymbol: false,
						lineStyle:{
							normal:{
								width:1,
							}
						},
            areaStyle: {
              color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(254, 116, 0, 0.2)' },
                { offset: 0.3, color: 'rgba(254, 116, 0,0.1)' },
                { offset: 1, color: 'rgba(254, 116, 0,0)' }
              ])
            }
          },
          {
            name: '沪深300',
            data: this.yzData.syfx300.NetValue,
            type: 'line',
            smooth: true,
						lineStyle:{
							normal:{
								width:1,
							}
						},
            showSymbol: false
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 获取调优后回测统计最优
    // 计算阶段统计数据的index值
    computeJdtjFunc: function () {
      let setIndex = 0;
      // 获取调优后的回测阶段统计
      let BacktestAnalysisResult = this.tyData.backTest.BacktestAnalysisResult;
      if (BacktestAnalysisResult.length > 0) {
        let newArr = [];
        BacktestAnalysisResult.forEach((item, index) => {
          let maxNum = 0;
          maxNum = item.ProfitLossRatio * item.RiseProbability * item.AvgSectionRate;
          newArr.push(maxNum);
        });
        var max = Math.max(...newArr);
        setIndex = newArr.map((item) => item).indexOf(max);
        return setIndex;
      } else {
        return setIndex;
      }
    },
    // 开启选择弹窗
    showSheet: function () {
      this.sheetShow = true;
    },
    // 取消弹窗
    onSheetCancel: function () {},
    // 弹窗选择条件
    onSheetSelect: function (index) {
      this.lshcMaxIndex = index;
      this.sheetShow = false;
    },
    // 设置收益同比
    setSyTongBi: function (num1, num2) {
      if (num1 == '--' || num2 == '--') {
        return '--'
      }
      var setNum = (1 + num2 / 100) / (1 + num1 / 100) - 1;
      // console.log(setNum,'==========',num1,num2,'-----------------',Number(setNum * 100).toFixed(2));
      return Number(setNum * 100).toFixed(2);
    },
    // 设置雷达图
    setRadar: function () {
      var chartRadar = this.$echarts.init(document.getElementById('radarEchars'));
      var option = {
        legend: {
          data: ['调优前', '调优后'],
          bottom: '5px', // 图例距底距离
          orient: 'horizontal',
          itemWidth: 12, // 图例图形宽高
          itemHeight: 8,
          itemGap: 16, // 图例各项之间距离
          textStyle: {
            // 图例字样式
            color: '#000000',
            fontSize: 10
          }
        },
        color: ['#286DF7', '#FE7400'],
        radar: {
          center: ['50%', '50%'],
          radius: '70%',
          indicator: [
            { name: '技术', max: 100 },
            { name: '避雷', max: 100 },
            { name: '题材', max: 100 },
            { name: '资金', max: 100 },
            { name: '基本', max: 100 }
          ],
          splitArea: {
            areaStyle: {
              color: ['#FFF']
            }
          },
          axisName: {
            // 坐标名样式
            color: 'rgba(102, 102, 102, 0.90)',
            textAlign: 'center'
          },
          splitLine: {
            //配置雷达图的每一圈的网格线颜色
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.10)'
            }
          },
          axisLine: {
            //配置雷达图的射线样式颜色
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.10)'
            }
          }
        },
        tooltip: {
          show: false
        },

        series: [
          {
            type: 'radar',
            name: '调优前',
            data: [
              {
                value: [
                  this.yzData.TechData.FenShu,
                  this.yzData.BiLeiData.FenShu,
                  this.yzData.TiCaiData.FenShu,
                  this.yzData.ZiJinData.FenShu,
                  this.yzData.BasicData.FenShu
                ],
                //
                areaStyle: {
                  color: 'rgba(40, 109, 247, .1)'
                },
                lineStyle: {
                  color: '#286DF7'
                },
                symbol: 'none'
              }
            ]
          },
          {
            type: 'radar',
            name: '调优后',
            data: [
              {
                value: [
                  this.tyData.TechData.FenShu,
                  this.tyData.BiLeiData.FenShu,
                  this.tyData.TiCaiData.FenShu,
                  this.tyData.ZiJinData.FenShu,
                  this.tyData.BasicData.FenShu
                ],
                //
                areaStyle: {
                  color: 'rgba(254, 116, 0, .1)'
                },
                lineStyle: {
                  color: '#FE7400'
                },
                symbol: 'none'
              }
            ]
          }
        ]
      };
      option && chartRadar.setOption(option);
      // var t = setTimeout(function () {
      //   chartRadar.setOption(option);
      //   chartRadar.resize();
      //   clearTimeout(t);
      // }, 200);
      // window.addEventListener('resize', () => {
      //   chartRadar.resize();
      // });
    },
    // 设置基本面财务雷达图
    setCaiWuRadar: function () {
      var chartCaiWuRadar = this.$echarts.init(document.getElementById('caiWuRadar'));
      var option = {
        legend: {
          data: ['调优前', '调优后'],
          bottom: '5px', // 图例距底距离
          orient: 'horizontal',
          itemWidth: 12, // 图例图形宽高
          itemHeight: 8,
          itemGap: 16, // 图例各项之间距离
          textStyle: {
            // 图例字样式
            color: '#000000',
            fontSize: 10
          }
        },
        color: ['#286DF7', '#FE7400'],
        radar: {
          center: ['50%', '50%'],
          radius: '70%',
          indicator: [
            { name: '盈利能力', max: 10 },
            { name: '现金流', max: 10 },
            { name: '偿债能力', max: 10 },
            { name: '营运能力', max: 10 },
            { name: '成长能力', max: 10 }
          ],
          splitArea: {
            areaStyle: {
              color: ['#FFF']
            }
          },
          axisName: {
            // 坐标名样式
            color: 'rgba(102, 102, 102, 0.90)',
            textAlign: 'center'
          },
          splitLine: {
            //配置雷达图的每一圈的网格线颜色
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.10)'
            }
          },
          axisLine: {
            //配置雷达图的射线样式颜色
            lineStyle: {
              color: 'rgba(0, 0, 0, 0.10)'
            }
          }
        },
        tooltip: {
          show: false
        },

        series: [
          {
            type: 'radar',
            name: '调优前',
            data: [
              {
                value: [
                  this.yzData.BasicData.YingLiNengLi,
                  this.yzData.BasicData.XianJinLiu,
                  this.yzData.BasicData.ChangZhaiNengLi,
                  this.yzData.BasicData.YunYingNengLi,
                  this.yzData.BasicData.ChengZhangNengLi
                ],
                //
                areaStyle: {
                  color: 'rgba(40, 109, 247, .1)'
                },
                lineStyle: {
                  color: '#286DF7'
                },
                symbol: 'none'
              }
            ]
          },
          {
            type: 'radar',
            name: '调优后',
            data: [
              {
                value: [
                  this.tyData.BasicData.YingLiNengLi,
                  this.tyData.BasicData.XianJinLiu,
                  this.tyData.BasicData.ChangZhaiNengLi,
                  this.tyData.BasicData.YunYingNengLi,
                  this.tyData.BasicData.ChengZhangNengLi
                ],
                //
                areaStyle: {
                  color: 'rgba(254, 116, 0, .1)'
                },
                lineStyle: {
                  color: '#FE7400'
                },
                symbol: 'none'
              }
            ]
          }
        ]
      };
      option && chartCaiWuRadar.setOption(option);
    },
    // 渲染行业分布
    renderHyfb: function () {
      const pieData = this.yzData.hq.HangYeFenBu;
      // 获取涨跌分布
      var chartDom = document.getElementById('hyfbFront');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          show: false,
          trigger: 'item'
          // formatter: function (param) {
          //   return param.marker + param.name + ': ' + toFixedNum(param.value * 100, 2, '%');
          // }
        },
        legend: {
          icon: 'circle',
          orient: 'horizontal', //水平显示
          bottom: 0,
          itemGap: 8, //间隙
          itemWidth: 6, //圆点直径
          align: 'left', //图例标记和文本的对齐。默认自动
          textStyle: {
            color: '#555',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '35%'],
            radius: ['25%', '50%'],
            legendHoverLink: true, //hover 时的联动高亮
            avoidLabelOverlap: true, //是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠。
            stillShowZeroSum: false, //是否在数据和为0（一般情况下所有数据为0） 的时候仍显示扇区。
            percentPrecision: '2', //饼图百分比数值的精度，默认保留小数点后两位。

            data: pieData.map((item) => ({
              value: item.ZhanBi,
              name: item.IndustryName
            })),

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(255, 255, 255, 0.5)'
              }
            },

            label: {
              //echarts饼图内部显示百分比设置
              show: false,
              position: 'inside', //outside 外部显示  inside 内部显示
              formatter: `{d}%`,
              color: '#ffffff', //颜色
              fontSize: 12 //字体大小
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    renderHyfb2: function () {
      const pieData = this.tyData.hq.HangYeFenBu;
      // 获取涨跌分布
      var chartDom = document.getElementById('hyfbBehind');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        tooltip: {
          show: false,
          trigger: 'item',
          formatter: function (param) {
            return param.marker + param.name + ': ' + toFixedNum(param.value * 100, 2, '%');
          }
        },
        legend: {
          icon: 'circle',
          orient: 'horizontal', //水平显示
          bottom: 0,
          itemGap: 8, //间隙
          itemWidth: 6, //圆点直径
          align: 'left', //图例标记和文本的对齐。默认自动
          textStyle: {
            color: '#555',
            fontSize: 12
          }
        },
        series: [
          {
            type: 'pie',
            center: ['50%', '35%'],
            radius: ['25%', '50%'],
            legendHoverLink: true, //hover 时的联动高亮
            avoidLabelOverlap: true, //是否启用防止标签重叠策略，默认开启，在标签拥挤重叠的情况下会挪动各个标签的位置，防止标签间的重叠。
            stillShowZeroSum: false, //是否在数据和为0（一般情况下所有数据为0） 的时候仍显示扇区。
            percentPrecision: '2', //饼图百分比数值的精度，默认保留小数点后两位。

            data: pieData.map((item) => ({
              value: item.ZhanBi,
              name: item.IndustryName
            })),

            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(255, 255, 255, 0.5)'
              }
            },

            label: {
              //echarts饼图内部显示百分比设置
              show: false,
              position: 'inside', //outside 外部显示  inside 内部显示
              formatter: `{d}%`,
              color: '#ffffff', //颜色
              fontSize: 12 //字体大小
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 设置 柱状图数据
    setBarChartData: function () {
			// 设置数据 - 因子数据
			let zjmYzStockZhanBiArrInfo = [];
			zjmYzStockZhanBiArrInfo = this.zjmYzStockZhanBiArr;
			zjmYzStockZhanBiArrInfo = zjmYzStockZhanBiArrInfo.map(Number);
			let firstTwo = zjmYzStockZhanBiArrInfo.slice(0, 2).reduce((a, b) => a + b, 0);
			let lastTwo = zjmYzStockZhanBiArrInfo.slice(-2).reduce((a, b) => a + b, 0);
			zjmYzStockZhanBiArrInfo = [firstTwo, ...zjmYzStockZhanBiArrInfo.slice(2, -2), lastTwo];
			// 设置数据 - 调优数据
			let zjmTyStockZhanBiArrInfo = [];
			zjmTyStockZhanBiArrInfo = this.zjmTyStockZhanBiArr;
			zjmTyStockZhanBiArrInfo = zjmTyStockZhanBiArrInfo.map(Number);
			let firstTwo2 = zjmTyStockZhanBiArrInfo.slice(0, 2).reduce((a, b) => a + b, 0);
			let lastTwo2 = zjmTyStockZhanBiArrInfo.slice(-2).reduce((a, b) => a + b, 0);
			zjmTyStockZhanBiArrInfo = [firstTwo2, ...zjmTyStockZhanBiArrInfo.slice(2, -2), lastTwo2];

      // 获取涨跌分布
      var chartDom = document.getElementById('barChartData');
      var myChart = this.$echarts.init(chartDom);
      var option;
      option = {
        legend: {
          data: ['调优前', '调优后'],
          icon: 'rect',
          itemWidth: 8,
          itemGap: 16,
          itemHeight: 3,
          itemWidth: 8,
          top: 0,
          textStyle: {
            color: '#999',
            fontSize: 12 // 文字的字体大小。
          }
        },
        color: ['#286DF7', '#FE7400'],
        grid: {
          left: 0,
          top: 40,
          right: 0,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [
            '≤-1亿',
            '-1亿~-5000万',
            '-5000万~0',
            '0~5000万',
            '5000万~1亿',
            '≥1亿'
          ],
          boundaryGap: true,
          axisTick: {
            show: false
          },
          axisLabel: {
            interval: 0, //横轴信息全部显示
            formatter: function (params) {
              let newParamsName = '';
              const paramsNameNumber = params.length; // 文字总长度
              const provideNumber = 5; //一行显示几个字
              const rowNumber = Math.ceil(paramsNameNumber / provideNumber);
              if (paramsNameNumber > provideNumber) {
                for (let p = 0; p < rowNumber; p++) {
                  const start = p * provideNumber;
                  const end = start + provideNumber;
                  const tempStr =
                    p === rowNumber - 1
                      ? params.substring(start, paramsNameNumber)
                      : params.substring(start, end) + '\n';
                  newParamsName += tempStr;
                }
              } else {
                newParamsName = params;
              }
              return newParamsName;
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '占比 %'
          }
        ],
        series: [
          {
            name: '调优前',
            type: 'bar',
            data: zjmYzStockZhanBiArrInfo,
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            }
          },
          {
            name: '调优后',
            type: 'bar',
            data: zjmTyStockZhanBiArrInfo,
            itemStyle: {
              barBorderRadius: [3, 3, 0, 0]
            }
          }
        ]
      };
      option && myChart.setOption(option);
    },
    // 调用功能号 关闭当前页面
    closeHtml: function () {
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    },
    // 调用功能号,打开分享
    shareHtml: function () {
      if (this.searchInfo) {
        console.log('我的分享地址');
        return;
      }
      // 请求AI报告分享数据
      let params = {
        yzData: JSON.stringify(this.yzData),
        tyData: JSON.stringify(this.tyData),
        bgTime: this.bgTime,
        mbName: this.s_name
      };
      shareReportTow(params)
        .then((result) => {
          if (result.err == 200) {
            window.location.href = result.data;
          } else {
          }
        })
        .catch((err) => {});
    },
    // 弹窗提示
    setTextMsgInfo: function (msg) {
      this.dialogTextShow = true;
      this.dialogTextMsg = msg;
    },
    // 关闭弹窗
    closeErrDialog: function () {
      this.dialogTextShow = false;
    },
    // 关闭错误弹窗
    closeDialogInfo: function () {
      this.dialogErrorMsg = false;
      window.location.href = 'dzh_browser_url&goto=0&screen=263';
    }
  },
  // 以下是生命周期钩子   注：没用到的钩子请自行删除
  /**
   * 在实例初始化之后，组件属性计算之前，如data属性等
   */
  beforeCreate() {},
  /**
   * 组件实例创建完成，属性已绑定，但DOM还未生成，$ el属性还不存在
   */
  created() {
    // 判断是否有classID
    this.classId = this.getUrlQuery('classId');
    if (this.classId == '') {
      this.bgTime = formtTime(new Date(), 'yyyy-MM-dd hh:mm:ss');
      // 获取地址栏中的单因子ID
      this.f_id = decodeURIComponent(this.getUrlQuery('factorid'));
      // 获取地址栏中的调优因子ID
      this.s_id = decodeURIComponent(this.getUrlQuery('mbid'));
      // 获取地址栏中的调优模版列表
      this.s_name = decodeURIComponent(this.getUrlQuery('mbname'));
      let nameArr = this.s_name.split(',');
      this.nameArr = nameArr;
      this.getAllData();
    } else {
      // 是分享,走分享逻辑
      // 查询分享的数据
      let params = {
        classId: this.classId
      };
      getReportRedisById(params)
        .then((result) => {
          if (result.err == 200) {
            // 获取数据请求数据
            // console.log('result.data', result.data);

            // 因子数据
            this.searchBgTime = result.data.bgTime;
            this.bgTime = this.searchBgTime;
            this.searchInfo = true;

            this.yzData = JSON.parse(result.data.yzData);
            this.tyData = JSON.parse(result.data.tyData);
            this.s_name = result.data.mbName;
            let nameArr = this.s_name.split(',');
            this.nameArr = nameArr;

            this.renderAllData();
          } else {
            this.mnQuery = true;
            this.showLoading = false;
          }
        })
        .catch((err) => {
					this.mnQuery = true;
					this.showLoading = false;
				});
    }
  },
  /**
   * 在挂载开始之前被调用：相关的 render 函数首次被调用。
   */
  beforeMount() {},
  /**
   * el 被新创建的 vm.$ el 替换，并挂载到实例上去之后调用该钩子。
   * 如果 root 实例挂载了一个文档内元素，当 mounted 被调用时 vm.$ el 也在文档内。
   */
  mounted() {},
  /**
   * 数据更新时调用，发生在虚拟 DOM 重新渲染和打补丁之前。
   * 你可以在这个钩子中进一步地更改状态，这不会触发附加的重渲染过程。
   */
  beforeUpdate() {},
  /**
   * 由于数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子。
   * 当这个钩子被调用时，组件 DOM 已经更新，所以你现在可以执行依赖于 DOM 的操作。
   */
  updated() {},
  /**
   * keep-alive 组件激活时调用。 仅针对keep-alive 组件有效
   */
  activated() {},
  /**
   * keep-alive 组件停用时调用。 仅针对keep-alive 组件有效
   */
  deactivated() {},
  /**
   * 实例销毁之前调用。在这一步，实例仍然完全可用。
   */
  beforeDestroy() {},
  /**
   * Vue 实例销毁后调用。调用后，Vue 实例指示的所有东西都会解绑定，
   * 所有的事件监听器会被移除，所有的子实例也会被销毁。
   */
  destroyed() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<!--使用了scoped属性之后，父组件的style样式将不会渗透到子组件中，-->
<!--然而子组件的根节点元素会同时被设置了scoped的父css样式和设置了scoped的子css样式影响，-->
<!--这么设计的目的是父组件可以对子组件根元素进行布局。-->
<style scoped lang="less">
// 背景图片样式
.background-report {
  background: url('../../assets/image/blockImg/report-background.png') top no-repeat;
  background-size: 100%;
  min-height: 100vh;
}

// 导航样式

.haider-info {
  padding-top: 44px;
}

.van-nav-bar {
  background-color: transparent;
}

::v-deep {
  .van-nav-bar__title {
    color: #fff !important;
    text-align: center;
    font-size: 16px;
    font-weight: 500;
  }

  .van-empty__description {
    color: #fff;
  }

  .van-hairline--bottom::after {
    border-bottom-width: 0px;
  }
}

.right-icon {
  width: 17px;
  height: 18.5px;
  // border: 1px solid red;
  background: url('../../assets/image/blockImg/Share.png') top no-repeat;
  background-size: 100%;
  font-size: 16px;
  display: block;
}

// 报告时间
.report-time {
  text-align: center;
  color: #fff;
  font-size: 12px;
  margin: 10px auto;
}

// 内容页样式
.report-content {
  height: calc(100vh - 130px);
  padding: 12px;
  overflow: hidden;
  overflow-y: auto;

  //   白色背景-公共
  .content-bg {
    background: #fff;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 8px;
  }

  // 一级标题
  .title-first-order {
    color: #222222;
    font-size: 16px;
    font-weight: 500;
  }

  // 二级标题
  .title-second-order {
    color: #222222;
    font-size: 14px;
    font-weight: 500;
  }

  // 三级标题
  .title-third-order {
    border-radius: 6px;
    padding: 6px 8px;
    background: rgba(0, 0, 0, 0.02);
    margin-top: 8px;
  }

  // 四级标题
  .title-fourth-order {
    color: #555;
    font-size: 14px;
    font-weight: 400;
  }

  // 灰色背景
  .background-gray {
    background: #f7f8fa;
    border-radius: 6px;
    padding: 12px 16px;
    text-align: justify !important;
    span {
      text-align: justify !important;
    }
  }

  // 涨标签
  .redTop {
    width: 10.5px;
    height: 6px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/red-top.png') top no-repeat;
    background-size: 100%;
    display: inline-block;
    margin-left: 4px;
  }

  // 跌标签
  .greenDown {
    width: 10.5px;
    height: 6px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/green-down.png') top no-repeat;
    background-size: 100%;
    display: inline-block;
    margin-left: 4px;
  }

  .rightArrow {
    width: 12px;
    height: 12px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/right-arrow.png') top no-repeat;
    background-size: 100%;
    display: inherit;
  }

  // 指针
  .pointerIcon {
    width: 14px;
    height: 14px;
    background: url('../../assets/image/blockImg/pointer.png') top no-repeat;
    background-size: 100%;
    display: inline-block;
  }

  // 红色上箭头
  .topArrow {
    width: 7px;
    height: 9px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/top-arrow.png') top no-repeat;
    background-size: 100%;
    display: block;
  }

  // 绿色下箭头
  .downArrow {
    width: 7px;
    height: 9px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/down-arrow.png') top no-repeat;
    background-size: 100%;
    display: block;
  }

  // 灰色帮助
  .helpGray {
    width: 16px;
    height: 16px;
    // border: 1px solid red;
    background: url('../../assets/image/blockImg/help-gray.png') top no-repeat;
    background-size: 100%;
    display: block;
  }

  // 红色文字
  .textRedInfo {
    color: #ef3939;
  }

  // 蓝色文字
  .textBlueInfo {
    color: #286df7;
  }

  // 绿色文字
  .textGreenInfo {
    color: #1eac4e;
  }

  //  灰色文字
  .textGray999Info {
    color: #999999;
  }

  .textGray555Info {
    color: #555555;
  }

  .marginBottom8 {
    margin-bottom: 8px;
  }

  .marginBottom16 {
    margin-bottom: 16px;
  }

  .padding8Info {
    padding: 8px 0;
  }

  .padding4Info {
    padding: 4px 0;
  }

  // 字体样式
  .font12Info {
    font-size: 12px;
  }

  .font14Info {
    font-size: 14px;
  }

  // 分割线样式 -- 公共
  .parting-line {
    width: calc(100% + 32px);
    height: 8px;
    background: #f8f9fc;
    margin: 16px 0;
    margin-left: -16px;
  }

  //   概览/走势/调优数据变化
  .content-gl {
    // 因子名称
    .gl-title {
      text-align: center;
      font-size: 16px;
      color: var(--colours-text-1, #222);
      font-weight: 500;
    }

    // 因子code
    .gl-code {
      text-align: center;
      color: var(--colours-text-3, #999);
      font-size: 12px;
      font-weight: 400;
    }

    // 调优参数
    .gl-tycs {
      .gl-tycs-title {
        color: #222;
        font-size: 14px;
      }

      .downI {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: url('../../assets/image/blockImg/down-one.png') top no-repeat;
        background-size: 100%;
        margin-left: 4px;
      }

      .topI {
        width: 10px;
        height: 10px;
        display: inline-block;
        background: url('../../assets/image/blockImg/top-one.png') top no-repeat;
        background-size: 100%;
        margin-left: 4px;
      }
    }

    // 调优参数列表
    .gl-item {
      ul {
        height: 20px;
        overflow: hidden;
      }

      li {
        display: inline-block;
        background: rgba(40, 109, 247, 0.05);
        border-radius: 53px;
        margin-right: 4px;
        padding: 2px 8px;
        color: var(--colours-blue, #3b85fe);
        text-align: center;
        font-size: 12px;
        margin-bottom: 6px;
      }
    }

    // 概述背景
    .gs-text-background {
      background: #f7f8fa;
      border-radius: 6px;
      margin: 16px 0;
      padding: 12px 16px;
      text-align: justify;

      // 文字概述样式
      .gs-text-info {
        font-size: 16px;
        color: #286df7;
      }

      .tg1 {
        color: #ef3939;
      }

      .tg2 {
        color: #1eac4e;
      }

      .dxShengJiang-down {
        color: #1eac4e;
      }

      .dxShengJiang-up {
        color: #ef3939;
      }

      .clTextBold {
        font-weight: bold;
      }
    }

    // 历史表现优秀,一般,较差样式
    .tag-signal1 {
      // 表现优秀
      color: #ef3939;
      font-size: 10px;
      font-weight: 400;
      border-radius: 4px;
      background: var(--colours-red-shallow, rgba(239, 57, 57, 0.1));
      padding: 2px 4px;
      margin-left: 8px;
    }

    .tag-signal2 {
      // 表现欠佳
      color: #1eac4e;
      font-size: 10px;
      font-weight: 400;
      border-radius: 4px;
      background: var(--colours-red-shallow, rgba(30, 172, 78, 0.1));
      padding: 2px 4px;
      margin-left: 8px;
    }

    .tag-signal3 {
      // 表现一般
      color: #999999;
      font-size: 10px;
      font-weight: 400;
      border-radius: 4px;
      background: var(--colours-red-shallow, #f7f8fa);
      padding: 2px 4px;
      margin-left: 8px;
    }

    // 走势收益图
    .tb-height {
      height: 170px;
      // padding: 12px 16px;
      padding: 5px 0;
      margin-top: 8px;
      margin-bottom: 16px;
    }

    // 调优数据变化
    .ty-data-info {
      margin-top: 8px;

      .data-title {
        font-size: 14px;
        font-weight: 400;
        color: #555;
      }

      .font12Info {
        font-size: 12px;
        font-weight: 400;
        color: #999;
      }

      .font16Info {
        color: #222;
        font-size: 16px;
        font-weight: 500;
      }

      // 居中
      .text-flex-conten {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        align-items: center;
        justify-content: space-between;
        padding: 8px 0;

        .item-left {
          font-size: 12px;
          font-weight: 400;
          color: #999;
        }

        .item-right {
          color: #222;
          font-size: 16px;
          font-weight: 500;
          display: flex;
          align-items: center;
        }
      }
    }
  }

  // 历史回测对比
  .lshc-info {
    .data-text {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }

    .text-left {
      text-align: left;
    }

    .text-right {
      text-align: right;
    }

    .data-text3 {
      color: #555;
      font-size: 12px;
      font-weight: 400;
    }

    .data-title-left {
      color: var(--colours-text-2, #555);
      font-size: 12px;
      font-weight: 400;
    }

    // 文字靠右
    .data-title-right {
      text-align: right;
      color: #222;
      font-size: 12px;
      font-weight: 500;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-end;
      align-items: center;
    }

    .text-right-icon {
      width: 4px;
      height: 3px;
      display: inline-block;
      background: url('../../assets/image/blockImg/xiala.png') top no-repeat;
      background-size: 100%;
      margin-left: 4px;
    }

    .flexIcon {
      display: flex;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-end;
      align-items: center;
    }
  }

  // 当日股池对比
  .drgc-info {
    .radarEchars {
      height: 240px;
    }

    .barEchars {
      height: 180px;
    }

    .zong-felx {
      display: flex !important;
      align-items: center !important;
    }

    // 分数左
    .fenshu-left-text {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }

    .right-flex {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-end;
      align-items: center;
    }

    // 分数右
    .fenshu-right-text {
      color: #222;
      font-size: 12px;
      font-weight: 500;
    }

    .fenshu-right-icon2 {
      display: grid;
      width: 10.5px;
      height: 6px;
    }

    // 一级标题
    .title-class-info {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: flex-start;
      justify-content: flex-start;
      align-items: center;

      // 标题左侧
      .title-left-class {
        color: #222;
        font-size: 16px;
        font-weight: 500;
      }

      // 标题中间部分
      .title-centre-class {
        margin-left: 12px;
        margin-right: auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: flex-start;
        align-items: center;

        .title-centre-text-lable {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          margin-right: 4px;
        }

        // 中间数字样式
        .title-centre-text-num {
          color: #222;
          font-size: 14px;
          font-weight: 500;
          margin-right: 4px;
        }
      }
    }

    // 技术分析-文字-中间样式
    .jsfx-centre-text {
      text-align: center;
    }

    // 技术分析-文字-右侧样式
    .jsfx-right-text {
      text-align: right;
    }

    // 技术分析-文字-左侧样式
    .jsfx-left-text {
      text-align: left;
    }

    // 技术分析-顶部文字
    .jsfx-top-text {
      color: #999;
      font-size: 12px;
      font-weight: 400;
    }

    // 技术分析-左侧能量条
    .jsfx-div-left {
      background: #0baf80;
      width: 100%;
      height: 6px;
      border-top-left-radius: 6px;
      border-bottom-left-radius: 6px;
    }

    .jsfx-div-center {
      background: rgba(0, 0, 0, 0.06);
      width: 100%;
      height: 6px;
    }

    .jsfx-div-right {
      background: #ef3939;
      width: 100%;
      height: 6px;
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
    }

    // 技术分析-底部-ICON
    .jsfx-bottom-icon-left {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #0baf80;
      display: inline-block;
      margin-right: 4px;
    }

    .jsfx-bottom-icon-center {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #e8e9eb;
      display: inline-block;
      margin-right: 4px;
    }

    .jsfx-bottom-icon-right {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #ef3939;
      display: inline-block;
      margin-right: 4px;
    }

    // 技术分析-底部-文字
    .jsfx-bottom-text {
      color: #555;
      font-size: 10px;
      font-weight: 400;
    }

    // 个股样式 - 涨
    .gegu-stock-red {
      width: 100%;
      height: 68px;
      padding: 8px 16px;
      border-radius: 8px;
      background: linear-gradient(180deg, #ffedef 0%, #fffbfb 100%);

      .stock-red-title {
        color: #121826;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      .stock-red-code {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
      }

      .stock-red-zhangfu {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        color: #ef3939;
        font-size: 14px;
        font-weight: 500;
      }
    }

    // 个股样式 - 跌
    .gegu-stock-green {
      width: 100%;
      height: 68px;
      padding: 8px 16px;
      border-radius: 8px;
      background: linear-gradient(180deg, #e6fbed 0%, #fafff9 100%);

      .stock-red-title {
        color: #121826;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      .stock-red-code {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
      }

      .stock-red-zhangfu {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        color: #1eac4e;
        font-size: 14px;
        font-weight: 500;
      }
    }

    // 个股样式 - 平
    .gegu-stock-gray {
      width: 100%;
      height: 68px;
      padding: 8px 16px;
      border-radius: 8px;
      background: linear-gradient(180deg, #f5f6f9 0%, rgba(245, 246, 249, 0) 100%);

      .stock-red-title {
        color: #121826;
        font-size: 14px;
        font-weight: 500;
        text-align: center;
      }

      .stock-red-code {
        color: #999;
        font-size: 12px;
        font-weight: 400;
        text-align: center;
      }

      .stock-red-zhangfu {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        color: #555;
        font-size: 14px;
        font-weight: 500;
      }
    }
		// 个股像模板(新)
		.gegu-stock-news {
      padding: 8px 16px;
      margin-bottom: 4px;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
      .stock-info-left {
        width: 50%;
      }
			.stock-red-title {
				font-size:14px;
				font-weight:500;
				color:#121826;
        margin-right: 8px;
        display: inline-block;
			}
			.stock-red-code {
        font-size: 12px;
        font-weight: 400;
        color:#999;
        margin-right:24px;
        display: inline-block;
			}
			.stock-red-zhangfu {
        display: inline-block;
        font-size: 14px;
        font-weight: 400;
        color: #555;
			}
      .stock-zhangfu-num {
        margin-left: 8px;
      } 
		}
    .gegu-stock-newsRed {
      border-radius: 8px;
      background: linear-gradient(90deg, #FFEDEF 0.06%, #FFFBFB 99.95%);
      .stock-zhangfu-num {
        color: #EF3939;
      } 
    }
    .gegu-stock-newsGreen {
      border-radius: 8px;
      background: linear-gradient(90deg, #E6FBED 0.06%, #FAFFF9 99.95%);
      .stock-zhangfu-num {
        color: #1EAC4E;
      } 
    }
    .gegu-stock-newsGray {
      border-radius: 8px;
      background: linear-gradient(90deg, #F5F6F9 0.06%, #FFF 99.95%);
      .stock-zhangfu-num {
        color: #555;
      } 
    }

    // 个股列表 - 涨
    .gegulist-stock-red {
      width: 100%;
      padding: 12px;
      border-radius: 8px;
      background: linear-gradient(180deg, #ffedef 0%, #fffbfb 100%);
      .top-stock-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
      }
      .stock-title-info {
        color: #121826;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }

      .stock-zhangfu-info {
        color: #ef3939;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 8px;
        margin-top: 6px;
      }

      .stock-num-info {
        border-radius: 6px;
        background: #fff;
        padding: 4px 12px;
        margin-bottom: 4px;
      }

      .stock-flex-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;

        .stock-name {
          color: #555;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
        }

        .stock-code {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
        }

        .stock-zhangfu {
          font-size: 14px;
          font-weight: 500;
          text-align: right;
        }
      }
    }

    // 个股列表 - 跌
    .gegulist-stock-green {
      width: 100%;
      padding: 12px;
      border-radius: 8px;
      background: linear-gradient(180deg, #e6fbed 0%, #fafff9 100%);
      .top-stock-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
      }
      .stock-title-info {
        color: #121826;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }

      .stock-zhangfu-info {
        color: #1eac4e;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 8px;
        margin-top: 6px;
      }

      .stock-num-info {
        border-radius: 6px;
        background: #fff;
        padding: 4px 12px;
        margin-bottom: 4px;
      }

      .stock-flex-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;

        .stock-name {
          color: #555;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
        }

        .stock-code {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
        }

        .stock-zhangfu {
          font-size: 14px;
          font-weight: 500;
          text-align: right;
        }
      }
    }

    // 个股列表 - 平
    .gegulist-stock-gray {
      width: 100%;
      padding: 12px;
      border-radius: 8px;
      background: linear-gradient(180deg, #f5f6f9 0%, rgba(245, 246, 249, 0) 100%);
      .top-stock-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;
        padding: 0 8px;
      }
      .stock-title-info {
        color: #121826;
        font-weight: 500;
        font-size: 14px;
        text-align: center;
      }

      .stock-zhangfu-info {
        color: #999;
        font-size: 16px;
        font-weight: 500;
        text-align: center;
        margin-bottom: 8px;
        margin-top: 6px;
      }

      .stock-fontSize12 {
        font-size: 12px;
        color: #999;
        font-weight: 400;
        text-align: center;
        margin-top: 6px;
      }

      .stock-num-info {
        border-radius: 6px;
        background: #fff;
        padding: 4px 12px;
        margin-bottom: 4px;
      }

      .stock-flex-info {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: center;
        justify-content: space-between;
        align-items: center;

        .stock-name {
          color: #555;
          font-size: 12px;
          font-weight: 500;
          text-align: center;
        }

        .stock-code {
          color: #999;
          font-size: 12px;
          font-weight: 400;
          text-align: center;
        }

        .stock-zhangfu {
          font-size: 14px;
          font-weight: 500;
          text-align: right;
        }
      }
    }

    // 行业分布对比
    .tb-height2 {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;

      .tb-chart {
        background: #f7f8fa;
        border-radius: 8px;
        width: 50%;

        .hyfb-text {
          font-size: 12px;
          color: #555;
          text-align: left;
          padding-left: 16px;
          padding-top: 4px;
        }

        .hyfb-chart {
          width: 100%;
          height: 170px;
        }
      }
    }
  }

  // 免责声明
  .statement-info {
    margin: 16px 0;
    color: #fff;
    font-size: 12px;
    font-weight: 500;
  }
}

// 遮罩样式
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
// 下拉列表样式
.content-sheet {
  .sheet-info {
    border-bottom: 1px solid #E5E5E5;
    padding: 16px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: flex-start;
    align-items: center;
  }
  .sheet-title {
    color: var(--colours-text-2, #555);
    font-size: 16px;
    font-weight: 500;
  }
  .sheet-title-select {
    color: #286DF7;
  }
  .sheet-span {
    color: var(--colours-orange, #FE7400);
    font-size: 10px;
    font-weight: 400;
    padding: 4px;
    border-radius: 2px;
    background: var(--colours-orange-shallow, rgba(254, 116, 0, 0.10));
    margin-left: 8px;
  }

}
.van-action-sheet__gap {
  background: #FFF;
}
</style>
